var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/utils/api.util.ts
import {
  useMutation,
  useQuery
} from "@tanstack/react-query";
var createApiQuery = (queryKey, request) => {
  return (variables, options) => {
    return useQuery(
      [queryKey, variables],
      () => __async(void 0, null, function* () {
        return yield Promise.resolve(request(variables)).then(
          (response) => response.data
        );
      }),
      options
    );
  };
};
var createApiMutation = (queryKey, request) => {
  return (options) => {
    return useMutation(
      typeof queryKey === "string" ? [queryKey] : queryKey,
      (variables) => __async(void 0, null, function* () {
        return yield Promise.resolve(request(variables)).then(
          (response) => response.data
        );
      }),
      options
    );
  };
};
var pathParams = (path, params) => {
  if (!params) return path;
  const keys = Object.keys(params).reduce((p, c) => {
    p[c] = String(params[c]);
    return p;
  }, {});
  return `${path}?${new URLSearchParams(keys).toString()}`;
};

// src/services/connector/client.ts
import axios from "axios";
var client = axios.create({
  // baseURL: process.env.VITE_CONNECTOR_API_URL,
  headers: {
    "Content-Type": "application/json"
  }
});
var createQuery = (queryKey, request) => createApiQuery(`connector-${queryKey}`, request);
var createMutation = (queryKey, request) => createApiMutation(
  `connector-${queryKey}`,
  request
);
var client_default = client;

// src/services/cornerstone/client.ts
import axios2 from "axios";
var client2 = axios2.create({
  headers: {
    "Content-Type": "application/json"
  }
});
var client_default2 = client2;
var createQuery2 = (queryKey, request) => createApiQuery(`cornerstone-${queryKey}`, request);
var AXIOS_INSTANCE = client2;
var customInstance = (config, options) => {
  const source = axios2.CancelToken.source();
  const promise = AXIOS_INSTANCE(__spreadProps(__spreadValues(__spreadValues({}, options), config), {
    cancelToken: source.token
  }));
  promise.cancel = () => {
    source.cancel("Query was cancelled by React Query");
  };
  return promise;
};

// src/services/connector/queries.ts
var queries_exports = {};
__export(queries_exports, {
  useAddresses: () => useAddresses,
  useOrders: () => useOrders,
  useProject: () => useProject,
  useProjects: () => useProjects,
  useProjectsV2: () => useProjectsV2
});

// src/services/connector/requests.ts
var requests_exports = {};
__export(requests_exports, {
  getAddresses: () => getAddresses,
  getMe: () => getMe,
  getOrders: () => getOrders,
  getProject: () => getProject,
  getProjects: () => getProjects,
  getProjectsV2: () => getProjectsV2,
  postBlurbyLoginToken: () => postBlurbyLoginToken
});
var getMe = () => {
  return client_default.get("/users/me");
};
var getAddresses = () => {
  return client_default.get("/users/addresses");
};
var getOrders = (params) => {
  return client_default.get(pathParams("/users/orders", params));
};
var getProject = ({
  project_id: projectId
}) => {
  return client_default.get(`/users/projects/${projectId}`);
};
var getProjects = (params) => {
  return client_default.get(pathParams("/users/projects", params));
};
var postBlurbyLoginToken = (data) => {
  return client_default.post("/users/blurby-login-token", data);
};
var getProjectsV2 = (params) => {
  return client_default.get(pathParams("/users/projects/v2", params));
};

// src/services/connector/queries.ts
var useAddresses = createQuery("addresses", getAddresses);
var useOrders = createQuery("orders", getOrders);
var useProject = createQuery("project", getProject);
var useProjects = createQuery("projects", getProjects);
var useProjectsV2 = createQuery("projects-v2", getProjectsV2);

// src/services/connector/mutations.ts
var mutations_exports = {};
__export(mutations_exports, {
  useBlurbyLoginToken: () => useBlurbyLoginToken
});
var useBlurbyLoginToken = createMutation(
  "blurby-login-token",
  postBlurbyLoginToken
);

// src/services/cornerstone/generated/index.ts
var generated_exports = {};
__export(generated_exports, {
  AuthAuthority: () => AuthAuthority,
  Country: () => Country,
  CoverPagesType: () => CoverPagesType,
  CoverRule: () => CoverRule,
  Direction: () => Direction,
  DiscountApplicationMode: () => DiscountApplicationMode,
  DiscountTarget: () => DiscountTarget,
  ErrorCode: () => ErrorCode,
  MonetaryAmountCurrency: () => MonetaryAmountCurrency,
  PricingRuleType: () => PricingRuleType,
  ProjectInternalStatus: () => ProjectInternalStatus,
  ProjectType: () => ProjectType,
  SearchCondition: () => SearchCondition,
  ShippingTier: () => ShippingTier,
  SupportedCurrency: () => SupportedCurrency,
  SupportedLanguage: () => SupportedLanguage,
  TransactionStatus: () => TransactionStatus,
  TransactionType: () => TransactionType,
  WidthCalculationType: () => WidthCalculationType,
  _AuthGroupSearchFieldsAllowedSortsItem: () => _AuthGroupSearchFieldsAllowedSortsItem,
  _DiscountSearchFieldsAllowedSortsItem: () => _DiscountSearchFieldsAllowedSortsItem,
  _ProjectSearchFieldsAllowedSortsItem: () => _ProjectSearchFieldsAllowedSortsItem,
  _TransactionSearchFieldsAllowedSortsItem: () => _TransactionSearchFieldsAllowedSortsItem,
  _UserSearchFieldsAllowedSortsItem: () => _UserSearchFieldsAllowedSortsItem,
  addAddress: () => addAddress,
  addItemV2: () => addItemV2,
  addPaymentMethod: () => addPaymentMethod,
  adminCreateDiscount: () => adminCreateDiscount,
  adminCreateUser: () => adminCreateUser,
  adminDeleteDiscount: () => adminDeleteDiscount,
  adminEditUser: () => adminEditUser,
  adminGetAdminPrinters: () => adminGetAdminPrinters,
  adminGetClusterTask: () => adminGetClusterTask,
  adminGetDiscount: () => adminGetDiscount,
  adminGetProject: () => adminGetProject,
  adminGetUser: () => adminGetUser,
  adminListClusterTasks: () => adminListClusterTasks,
  adminQueryClusterTasks: () => adminQueryClusterTasks,
  adminResendForgotPasswordEmail: () => adminResendForgotPasswordEmail,
  adminResendRegistrationEmail: () => adminResendRegistrationEmail,
  adminRoutingRegions: () => adminRoutingRegions,
  adminSearchDiscounts: () => adminSearchDiscounts,
  adminSearchProjects: () => adminSearchProjects,
  adminSearchUsers: () => adminSearchUsers,
  adminSetDiscountEnabled: () => adminSetDiscountEnabled,
  adminUpdateDiscount: () => adminUpdateDiscount,
  adminUpdateRoutingRegions: () => adminUpdateRoutingRegions,
  changePassword: () => changePassword,
  checkoutPreview: () => checkoutPreview,
  clearCart: () => clearCart,
  confirmForgotPassword: () => confirmForgotPassword,
  confirmSignupRegistration: () => confirmSignupRegistration,
  createBraintreeClientToken: () => createBraintreeClientToken,
  createCheckoutV2: () => createCheckoutV2,
  createProject: () => createProject,
  createTestDiscount: () => createTestDiscount,
  createTestProject: () => createTestProject,
  deleteAddress: () => deleteAddress,
  deletePaymentMethod: () => deletePaymentMethod,
  disableProject: () => disableProject,
  editMyUser: () => editMyUser,
  editPaymentMethod: () => editPaymentMethod,
  forgotPassword: () => forgotPassword,
  getAddAddressMutationOptions: () => getAddAddressMutationOptions,
  getAddItemV2MutationOptions: () => getAddItemV2MutationOptions,
  getAddPaymentMethodMutationOptions: () => getAddPaymentMethodMutationOptions,
  getAddress: () => getAddress,
  getAdminCreateDiscountMutationOptions: () => getAdminCreateDiscountMutationOptions,
  getAdminCreateUserMutationOptions: () => getAdminCreateUserMutationOptions,
  getAdminDeleteDiscountMutationOptions: () => getAdminDeleteDiscountMutationOptions,
  getAdminEditUserMutationOptions: () => getAdminEditUserMutationOptions,
  getAdminGetAdminPrintersQueryKey: () => getAdminGetAdminPrintersQueryKey,
  getAdminGetAdminPrintersQueryOptions: () => getAdminGetAdminPrintersQueryOptions,
  getAdminGetClusterTaskMutationOptions: () => getAdminGetClusterTaskMutationOptions,
  getAdminGetDiscountQueryKey: () => getAdminGetDiscountQueryKey,
  getAdminGetDiscountQueryOptions: () => getAdminGetDiscountQueryOptions,
  getAdminGetProjectQueryKey: () => getAdminGetProjectQueryKey,
  getAdminGetProjectQueryOptions: () => getAdminGetProjectQueryOptions,
  getAdminGetUserQueryKey: () => getAdminGetUserQueryKey,
  getAdminGetUserQueryOptions: () => getAdminGetUserQueryOptions,
  getAdminListClusterTasksQueryKey: () => getAdminListClusterTasksQueryKey,
  getAdminListClusterTasksQueryOptions: () => getAdminListClusterTasksQueryOptions,
  getAdminQueryClusterTasksMutationOptions: () => getAdminQueryClusterTasksMutationOptions,
  getAdminResendForgotPasswordEmailMutationOptions: () => getAdminResendForgotPasswordEmailMutationOptions,
  getAdminResendRegistrationEmailMutationOptions: () => getAdminResendRegistrationEmailMutationOptions,
  getAdminRoutingRegionsQueryKey: () => getAdminRoutingRegionsQueryKey,
  getAdminRoutingRegionsQueryOptions: () => getAdminRoutingRegionsQueryOptions,
  getAdminSearchDiscountsMutationOptions: () => getAdminSearchDiscountsMutationOptions,
  getAdminSearchProjectsMutationOptions: () => getAdminSearchProjectsMutationOptions,
  getAdminSearchUsersMutationOptions: () => getAdminSearchUsersMutationOptions,
  getAdminSetDiscountEnabledMutationOptions: () => getAdminSetDiscountEnabledMutationOptions,
  getAdminUpdateDiscountMutationOptions: () => getAdminUpdateDiscountMutationOptions,
  getAdminUpdateRoutingRegionsMutationOptions: () => getAdminUpdateRoutingRegionsMutationOptions,
  getCartV2: () => getCartV2,
  getChangePasswordMutationOptions: () => getChangePasswordMutationOptions,
  getCheckoutPreviewMutationOptions: () => getCheckoutPreviewMutationOptions,
  getClearCartMutationOptions: () => getClearCartMutationOptions,
  getConfirmForgotPasswordMutationOptions: () => getConfirmForgotPasswordMutationOptions,
  getConfirmSignupRegistrationMutationOptions: () => getConfirmSignupRegistrationMutationOptions,
  getConstants: () => getConstants,
  getCreateBraintreeClientTokenMutationOptions: () => getCreateBraintreeClientTokenMutationOptions,
  getCreateCheckoutV2MutationOptions: () => getCreateCheckoutV2MutationOptions,
  getCreateProjectMutationOptions: () => getCreateProjectMutationOptions,
  getCreateTestDiscountMutationOptions: () => getCreateTestDiscountMutationOptions,
  getCreateTestProjectMutationOptions: () => getCreateTestProjectMutationOptions,
  getDeleteAddressMutationOptions: () => getDeleteAddressMutationOptions,
  getDeletePaymentMethodMutationOptions: () => getDeletePaymentMethodMutationOptions,
  getDisableProjectMutationOptions: () => getDisableProjectMutationOptions,
  getEditMyUserMutationOptions: () => getEditMyUserMutationOptions,
  getEditPaymentMethodMutationOptions: () => getEditPaymentMethodMutationOptions,
  getForgotPasswordMutationOptions: () => getForgotPasswordMutationOptions,
  getGetAddressQueryKey: () => getGetAddressQueryKey,
  getGetAddressQueryOptions: () => getGetAddressQueryOptions,
  getGetCartV2QueryKey: () => getGetCartV2QueryKey,
  getGetCartV2QueryOptions: () => getGetCartV2QueryOptions,
  getGetConstantsQueryKey: () => getGetConstantsQueryKey,
  getGetConstantsQueryOptions: () => getGetConstantsQueryOptions,
  getGetPricingRulesQueryKey: () => getGetPricingRulesQueryKey,
  getGetPricingRulesQueryOptions: () => getGetPricingRulesQueryOptions,
  getGetProductRulesQueryKey: () => getGetProductRulesQueryKey,
  getGetProductRulesQueryOptions: () => getGetProductRulesQueryOptions,
  getGetProductSpecificationsQueryKey: () => getGetProductSpecificationsQueryKey,
  getGetProductSpecificationsQueryOptions: () => getGetProductSpecificationsQueryOptions,
  getGetProjectQueryKey: () => getGetProjectQueryKey,
  getGetProjectQueryOptions: () => getGetProjectQueryOptions,
  getGetProjectsQueryKey: () => getGetProjectsQueryKey,
  getGetProjectsQueryOptions: () => getGetProjectsQueryOptions,
  getGetUserAddressesQueryKey: () => getGetUserAddressesQueryKey,
  getGetUserAddressesQueryOptions: () => getGetUserAddressesQueryOptions,
  getGetVolumeDiscountsQueryKey: () => getGetVolumeDiscountsQueryKey,
  getGetVolumeDiscountsQueryOptions: () => getGetVolumeDiscountsQueryOptions,
  getHealthQueryKey: () => getHealthQueryKey,
  getHealthQueryOptions: () => getHealthQueryOptions,
  getLinkUserToBlurbyUserMutationOptions: () => getLinkUserToBlurbyUserMutationOptions,
  getListAuthGroupsQueryKey: () => getListAuthGroupsQueryKey,
  getListAuthGroupsQueryOptions: () => getListAuthGroupsQueryOptions,
  getListPaymentMethodsQueryKey: () => getListPaymentMethodsQueryKey,
  getListPaymentMethodsQueryOptions: () => getListPaymentMethodsQueryOptions,
  getLoginMutationOptions: () => getLoginMutationOptions,
  getLoginV2MutationOptions: () => getLoginV2MutationOptions,
  getLogoutMutationOptions: () => getLogoutMutationOptions,
  getMeQueryKey: () => getMeQueryKey,
  getMeQueryOptions: () => getMeQueryOptions,
  getPingQueryKey: () => getPingQueryKey,
  getPingQueryOptions: () => getPingQueryOptions,
  getPlaceOrderMutationOptions: () => getPlaceOrderMutationOptions,
  getPricingRules: () => getPricingRules,
  getPrivateClientsHealthQueryKey: () => getPrivateClientsHealthQueryKey,
  getPrivateClientsHealthQueryOptions: () => getPrivateClientsHealthQueryOptions,
  getProductRules: () => getProductRules,
  getProductSpecifications: () => getProductSpecifications,
  getProject: () => getProject2,
  getProjects: () => getProjects2,
  getRefreshTokenMutationOptions: () => getRefreshTokenMutationOptions,
  getRegisterMutationOptions: () => getRegisterMutationOptions,
  getRemoveItemV2MutationOptions: () => getRemoveItemV2MutationOptions,
  getRequestRegistrationTokenMutationOptions: () => getRequestRegistrationTokenMutationOptions,
  getSignUpMutationOptions: () => getSignUpMutationOptions,
  getSuperAdminCreateAuthGroupMutationOptions: () => getSuperAdminCreateAuthGroupMutationOptions,
  getSuperAdminGetAuthGroupQueryKey: () => getSuperAdminGetAuthGroupQueryKey,
  getSuperAdminGetAuthGroupQueryOptions: () => getSuperAdminGetAuthGroupQueryOptions,
  getSuperAdminSearchAuthGroupsMutationOptions: () => getSuperAdminSearchAuthGroupsMutationOptions,
  getSuperAdminUpdateAuthGroupMutationOptions: () => getSuperAdminUpdateAuthGroupMutationOptions,
  getTestUserMutationOptions: () => getTestUserMutationOptions,
  getUpdateAddressMutationOptions: () => getUpdateAddressMutationOptions,
  getUpdateCheckoutMutationOptions: () => getUpdateCheckoutMutationOptions,
  getUpdateQuantityV2MutationOptions: () => getUpdateQuantityV2MutationOptions,
  getUserAddresses: () => getUserAddresses,
  getVolumeDiscounts: () => getVolumeDiscounts,
  health: () => health,
  linkUserToBlurbyUser: () => linkUserToBlurbyUser,
  listAuthGroups: () => listAuthGroups,
  listPaymentMethods: () => listPaymentMethods,
  login: () => login,
  loginV2: () => loginV2,
  logout: () => logout,
  me: () => me,
  ping: () => ping,
  placeOrder: () => placeOrder,
  privateClientsHealth: () => privateClientsHealth,
  refreshToken: () => refreshToken,
  register: () => register,
  removeItemV2: () => removeItemV2,
  requestRegistrationToken: () => requestRegistrationToken,
  signUp: () => signUp,
  superAdminCreateAuthGroup: () => superAdminCreateAuthGroup,
  superAdminGetAuthGroup: () => superAdminGetAuthGroup,
  superAdminSearchAuthGroups: () => superAdminSearchAuthGroups,
  superAdminUpdateAuthGroup: () => superAdminUpdateAuthGroup,
  testUser: () => testUser,
  updateAddress: () => updateAddress,
  updateCheckout: () => updateCheckout,
  updateQuantityV2: () => updateQuantityV2,
  useAddAddress: () => useAddAddress,
  useAddItemV2: () => useAddItemV2,
  useAddPaymentMethod: () => useAddPaymentMethod,
  useAdminCreateDiscount: () => useAdminCreateDiscount,
  useAdminCreateUser: () => useAdminCreateUser,
  useAdminDeleteDiscount: () => useAdminDeleteDiscount,
  useAdminEditUser: () => useAdminEditUser,
  useAdminGetAdminPrinters: () => useAdminGetAdminPrinters,
  useAdminGetClusterTask: () => useAdminGetClusterTask,
  useAdminGetDiscount: () => useAdminGetDiscount,
  useAdminGetProject: () => useAdminGetProject,
  useAdminGetUser: () => useAdminGetUser,
  useAdminListClusterTasks: () => useAdminListClusterTasks,
  useAdminQueryClusterTasks: () => useAdminQueryClusterTasks,
  useAdminResendForgotPasswordEmail: () => useAdminResendForgotPasswordEmail,
  useAdminResendRegistrationEmail: () => useAdminResendRegistrationEmail,
  useAdminRoutingRegions: () => useAdminRoutingRegions,
  useAdminSearchDiscounts: () => useAdminSearchDiscounts,
  useAdminSearchProjects: () => useAdminSearchProjects,
  useAdminSearchUsers: () => useAdminSearchUsers,
  useAdminSetDiscountEnabled: () => useAdminSetDiscountEnabled,
  useAdminUpdateDiscount: () => useAdminUpdateDiscount,
  useAdminUpdateRoutingRegions: () => useAdminUpdateRoutingRegions,
  useChangePassword: () => useChangePassword,
  useCheckoutPreview: () => useCheckoutPreview,
  useClearCart: () => useClearCart,
  useConfirmForgotPassword: () => useConfirmForgotPassword,
  useConfirmSignupRegistration: () => useConfirmSignupRegistration,
  useCreateBraintreeClientToken: () => useCreateBraintreeClientToken,
  useCreateCheckoutV2: () => useCreateCheckoutV2,
  useCreateProject: () => useCreateProject,
  useCreateTestDiscount: () => useCreateTestDiscount,
  useCreateTestProject: () => useCreateTestProject,
  useDeleteAddress: () => useDeleteAddress,
  useDeletePaymentMethod: () => useDeletePaymentMethod,
  useDisableProject: () => useDisableProject,
  useEditMyUser: () => useEditMyUser,
  useEditPaymentMethod: () => useEditPaymentMethod,
  useForgotPassword: () => useForgotPassword,
  useGetAddress: () => useGetAddress,
  useGetCartV2: () => useGetCartV2,
  useGetConstants: () => useGetConstants,
  useGetPricingRules: () => useGetPricingRules,
  useGetProductRules: () => useGetProductRules,
  useGetProductSpecifications: () => useGetProductSpecifications,
  useGetProject: () => useGetProject,
  useGetProjects: () => useGetProjects,
  useGetUserAddresses: () => useGetUserAddresses,
  useGetVolumeDiscounts: () => useGetVolumeDiscounts,
  useHealth: () => useHealth,
  useLinkUserToBlurbyUser: () => useLinkUserToBlurbyUser,
  useListAuthGroups: () => useListAuthGroups,
  useListPaymentMethods: () => useListPaymentMethods,
  useLogin: () => useLogin,
  useLoginV2: () => useLoginV2,
  useLogout: () => useLogout,
  useMe: () => useMe,
  usePing: () => usePing,
  usePlaceOrder: () => usePlaceOrder,
  usePrivateClientsHealth: () => usePrivateClientsHealth,
  useRefreshToken: () => useRefreshToken,
  useRegister: () => useRegister,
  useRemoveItemV2: () => useRemoveItemV2,
  useRequestRegistrationToken: () => useRequestRegistrationToken,
  useSignUp: () => useSignUp,
  useSuperAdminCreateAuthGroup: () => useSuperAdminCreateAuthGroup,
  useSuperAdminGetAuthGroup: () => useSuperAdminGetAuthGroup,
  useSuperAdminSearchAuthGroups: () => useSuperAdminSearchAuthGroups,
  useSuperAdminUpdateAuthGroup: () => useSuperAdminUpdateAuthGroup,
  useTestUser: () => useTestUser,
  useUpdateAddress: () => useUpdateAddress,
  useUpdateCheckout: () => useUpdateCheckout,
  useUpdateQuantityV2: () => useUpdateQuantityV2
});

// src/services/cornerstone/generated/rest-user-controller/rest-user-controller.ts
import { useMutation as useMutation2, useQuery as useQuery2 } from "@tanstack/react-query";
var editPaymentMethod = (paymentMethodToken, userSettingsPaymentEditMethodRequest, options) => {
  return customInstance(
    {
      url: `/users/settings/payment-methods/${paymentMethodToken}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: userSettingsPaymentEditMethodRequest
    },
    options
  );
};
var getEditPaymentMethodMutationOptions = (options) => {
  const mutationKey = ["editPaymentMethod"];
  const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : __spreadProps(__spreadValues({}, options), { mutation: __spreadProps(__spreadValues({}, options.mutation), { mutationKey }) }) : { mutation: { mutationKey }, request: void 0 };
  const mutationFn = (props) => {
    const { paymentMethodToken, data } = props != null ? props : {};
    return editPaymentMethod(paymentMethodToken, data, requestOptions);
  };
  return __spreadValues({ mutationFn }, mutationOptions);
};
var useEditPaymentMethod = (options) => {
  const mutationOptions = getEditPaymentMethodMutationOptions(options);
  return useMutation2(mutationOptions);
};
var deletePaymentMethod = (paymentMethodToken, options) => {
  return customInstance(
    {
      url: `/users/settings/payment-methods/${paymentMethodToken}`,
      method: "DELETE"
    },
    options
  );
};
var getDeletePaymentMethodMutationOptions = (options) => {
  const mutationKey = ["deletePaymentMethod"];
  const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : __spreadProps(__spreadValues({}, options), { mutation: __spreadProps(__spreadValues({}, options.mutation), { mutationKey }) }) : { mutation: { mutationKey }, request: void 0 };
  const mutationFn = (props) => {
    const { paymentMethodToken } = props != null ? props : {};
    return deletePaymentMethod(paymentMethodToken, requestOptions);
  };
  return __spreadValues({ mutationFn }, mutationOptions);
};
var useDeletePaymentMethod = (options) => {
  const mutationOptions = getDeletePaymentMethodMutationOptions(options);
  return useMutation2(mutationOptions);
};
var me = (options, signal) => {
  return customInstance(
    { url: `/users/me`, method: "GET", signal },
    options
  );
};
var getMeQueryKey = () => {
  return [`/users/me`];
};
var getMeQueryOptions = (options) => {
  var _a;
  const { query: queryOptions, request: requestOptions } = options != null ? options : {};
  const queryKey = (_a = queryOptions == null ? void 0 : queryOptions.queryKey) != null ? _a : getMeQueryKey();
  const queryFn = ({ signal }) => me(requestOptions, signal);
  return __spreadValues({ queryKey, queryFn }, queryOptions);
};
function useMe(options) {
  const queryOptions = getMeQueryOptions(options);
  const query = useQuery2(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var editMyUser = (userEditRequest, options) => {
  return customInstance(
    {
      url: `/users/me`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: userEditRequest
    },
    options
  );
};
var getEditMyUserMutationOptions = (options) => {
  const mutationKey = ["editMyUser"];
  const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : __spreadProps(__spreadValues({}, options), { mutation: __spreadProps(__spreadValues({}, options.mutation), { mutationKey }) }) : { mutation: { mutationKey }, request: void 0 };
  const mutationFn = (props) => {
    const { data } = props != null ? props : {};
    return editMyUser(data, requestOptions);
  };
  return __spreadValues({ mutationFn }, mutationOptions);
};
var useEditMyUser = (options) => {
  const mutationOptions = getEditMyUserMutationOptions(options);
  return useMutation2(mutationOptions);
};
var listPaymentMethods = (options, signal) => {
  return customInstance(
    { url: `/users/settings/payment-methods`, method: "GET", signal },
    options
  );
};
var getListPaymentMethodsQueryKey = () => {
  return [`/users/settings/payment-methods`];
};
var getListPaymentMethodsQueryOptions = (options) => {
  var _a;
  const { query: queryOptions, request: requestOptions } = options != null ? options : {};
  const queryKey = (_a = queryOptions == null ? void 0 : queryOptions.queryKey) != null ? _a : getListPaymentMethodsQueryKey();
  const queryFn = ({ signal }) => listPaymentMethods(requestOptions, signal);
  return __spreadValues({ queryKey, queryFn }, queryOptions);
};
function useListPaymentMethods(options) {
  const queryOptions = getListPaymentMethodsQueryOptions(options);
  const query = useQuery2(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var addPaymentMethod = (userSettingsPaymentAddMethodRequest, options, signal) => {
  return customInstance(
    {
      url: `/users/settings/payment-methods`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: userSettingsPaymentAddMethodRequest,
      signal
    },
    options
  );
};
var getAddPaymentMethodMutationOptions = (options) => {
  const mutationKey = ["addPaymentMethod"];
  const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : __spreadProps(__spreadValues({}, options), { mutation: __spreadProps(__spreadValues({}, options.mutation), { mutationKey }) }) : { mutation: { mutationKey }, request: void 0 };
  const mutationFn = (props) => {
    const { data } = props != null ? props : {};
    return addPaymentMethod(data, requestOptions);
  };
  return __spreadValues({ mutationFn }, mutationOptions);
};
var useAddPaymentMethod = (options) => {
  const mutationOptions = getAddPaymentMethodMutationOptions(options);
  return useMutation2(mutationOptions);
};
var linkUserToBlurbyUser = (userLinkBlurbyRequest, options, signal) => {
  return customInstance(
    {
      url: `/users/link-blurby`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: userLinkBlurbyRequest,
      signal
    },
    options
  );
};
var getLinkUserToBlurbyUserMutationOptions = (options) => {
  const mutationKey = ["linkUserToBlurbyUser"];
  const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : __spreadProps(__spreadValues({}, options), { mutation: __spreadProps(__spreadValues({}, options.mutation), { mutationKey }) }) : { mutation: { mutationKey }, request: void 0 };
  const mutationFn = (props) => {
    const { data } = props != null ? props : {};
    return linkUserToBlurbyUser(data, requestOptions);
  };
  return __spreadValues({ mutationFn }, mutationOptions);
};
var useLinkUserToBlurbyUser = (options) => {
  const mutationOptions = getLinkUserToBlurbyUserMutationOptions(options);
  return useMutation2(mutationOptions);
};
var changePassword = (userChangePasswordRequest, options, signal) => {
  return customInstance(
    {
      url: `/users/change-password`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: userChangePasswordRequest,
      signal
    },
    options
  );
};
var getChangePasswordMutationOptions = (options) => {
  const mutationKey = ["changePassword"];
  const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : __spreadProps(__spreadValues({}, options), { mutation: __spreadProps(__spreadValues({}, options.mutation), { mutationKey }) }) : { mutation: { mutationKey }, request: void 0 };
  const mutationFn = (props) => {
    const { data } = props != null ? props : {};
    return changePassword(data, requestOptions);
  };
  return __spreadValues({ mutationFn }, mutationOptions);
};
var useChangePassword = (options) => {
  const mutationOptions = getChangePasswordMutationOptions(options);
  return useMutation2(mutationOptions);
};

// src/services/cornerstone/generated/rest-super-admin-controller/rest-super-admin-controller.ts
import { useMutation as useMutation3, useQuery as useQuery3 } from "@tanstack/react-query";
var superAdminGetAuthGroup = (authGroupId, options, signal) => {
  return customInstance(
    { url: `/super-admin/${authGroupId}`, method: "GET", signal },
    options
  );
};
var getSuperAdminGetAuthGroupQueryKey = (authGroupId) => {
  return [`/super-admin/${authGroupId}`];
};
var getSuperAdminGetAuthGroupQueryOptions = (authGroupId, options) => {
  var _a;
  const { query: queryOptions, request: requestOptions } = options != null ? options : {};
  const queryKey = (_a = queryOptions == null ? void 0 : queryOptions.queryKey) != null ? _a : getSuperAdminGetAuthGroupQueryKey(authGroupId);
  const queryFn = ({ signal }) => superAdminGetAuthGroup(authGroupId, requestOptions, signal);
  return __spreadValues({
    queryKey,
    queryFn,
    enabled: !!authGroupId
  }, queryOptions);
};
function useSuperAdminGetAuthGroup(authGroupId, options) {
  const queryOptions = getSuperAdminGetAuthGroupQueryOptions(
    authGroupId,
    options
  );
  const query = useQuery3(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var superAdminUpdateAuthGroup = (authGroupId, authGroupUpdateRequest, options) => {
  return customInstance(
    {
      url: `/super-admin/${authGroupId}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: authGroupUpdateRequest
    },
    options
  );
};
var getSuperAdminUpdateAuthGroupMutationOptions = (options) => {
  const mutationKey = ["superAdminUpdateAuthGroup"];
  const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : __spreadProps(__spreadValues({}, options), { mutation: __spreadProps(__spreadValues({}, options.mutation), { mutationKey }) }) : { mutation: { mutationKey }, request: void 0 };
  const mutationFn = (props) => {
    const { authGroupId, data } = props != null ? props : {};
    return superAdminUpdateAuthGroup(authGroupId, data, requestOptions);
  };
  return __spreadValues({ mutationFn }, mutationOptions);
};
var useSuperAdminUpdateAuthGroup = (options) => {
  const mutationOptions = getSuperAdminUpdateAuthGroupMutationOptions(options);
  return useMutation3(mutationOptions);
};
var superAdminCreateAuthGroup = (authGroupCreateRequest, options, signal) => {
  return customInstance(
    {
      url: `/super-admin`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: authGroupCreateRequest,
      signal
    },
    options
  );
};
var getSuperAdminCreateAuthGroupMutationOptions = (options) => {
  const mutationKey = ["superAdminCreateAuthGroup"];
  const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : __spreadProps(__spreadValues({}, options), { mutation: __spreadProps(__spreadValues({}, options.mutation), { mutationKey }) }) : { mutation: { mutationKey }, request: void 0 };
  const mutationFn = (props) => {
    const { data } = props != null ? props : {};
    return superAdminCreateAuthGroup(data, requestOptions);
  };
  return __spreadValues({ mutationFn }, mutationOptions);
};
var useSuperAdminCreateAuthGroup = (options) => {
  const mutationOptions = getSuperAdminCreateAuthGroupMutationOptions(options);
  return useMutation3(mutationOptions);
};
var superAdminSearchAuthGroups = (filterSearch, params, options, signal) => {
  return customInstance(
    {
      url: `/super-admin/search/auth-groups`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: filterSearch,
      params,
      signal
    },
    options
  );
};
var getSuperAdminSearchAuthGroupsMutationOptions = (options) => {
  const mutationKey = ["superAdminSearchAuthGroups"];
  const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : __spreadProps(__spreadValues({}, options), { mutation: __spreadProps(__spreadValues({}, options.mutation), { mutationKey }) }) : { mutation: { mutationKey }, request: void 0 };
  const mutationFn = (props) => {
    const { data, params } = props != null ? props : {};
    return superAdminSearchAuthGroups(data, params, requestOptions);
  };
  return __spreadValues({ mutationFn }, mutationOptions);
};
var useSuperAdminSearchAuthGroups = (options) => {
  const mutationOptions = getSuperAdminSearchAuthGroupsMutationOptions(options);
  return useMutation3(mutationOptions);
};
var listAuthGroups = (options, signal) => {
  return customInstance(
    { url: `/super-admin/auth-groups`, method: "GET", signal },
    options
  );
};
var getListAuthGroupsQueryKey = () => {
  return [`/super-admin/auth-groups`];
};
var getListAuthGroupsQueryOptions = (options) => {
  var _a;
  const { query: queryOptions, request: requestOptions } = options != null ? options : {};
  const queryKey = (_a = queryOptions == null ? void 0 : queryOptions.queryKey) != null ? _a : getListAuthGroupsQueryKey();
  const queryFn = ({
    signal
  }) => listAuthGroups(requestOptions, signal);
  return __spreadValues({ queryKey, queryFn }, queryOptions);
};
function useListAuthGroups(options) {
  const queryOptions = getListAuthGroupsQueryOptions(options);
  const query = useQuery3(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}

// src/services/cornerstone/generated/rest-admin-controller/rest-admin-controller.ts
import { useMutation as useMutation4, useQuery as useQuery4 } from "@tanstack/react-query";
var adminGetUser = (id, options, signal) => {
  return customInstance(
    { url: `/admin/users/${id}`, method: "GET", signal },
    options
  );
};
var getAdminGetUserQueryKey = (id) => {
  return [`/admin/users/${id}`];
};
var getAdminGetUserQueryOptions = (id, options) => {
  var _a;
  const { query: queryOptions, request: requestOptions } = options != null ? options : {};
  const queryKey = (_a = queryOptions == null ? void 0 : queryOptions.queryKey) != null ? _a : getAdminGetUserQueryKey(id);
  const queryFn = ({
    signal
  }) => adminGetUser(id, requestOptions, signal);
  return __spreadValues({
    queryKey,
    queryFn,
    enabled: !!id
  }, queryOptions);
};
function useAdminGetUser(id, options) {
  const queryOptions = getAdminGetUserQueryOptions(id, options);
  const query = useQuery4(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var adminEditUser = (id, userEditAdminRequest, options) => {
  return customInstance(
    {
      url: `/admin/users/${id}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: userEditAdminRequest
    },
    options
  );
};
var getAdminEditUserMutationOptions = (options) => {
  const mutationKey = ["adminEditUser"];
  const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : __spreadProps(__spreadValues({}, options), { mutation: __spreadProps(__spreadValues({}, options.mutation), { mutationKey }) }) : { mutation: { mutationKey }, request: void 0 };
  const mutationFn = (props) => {
    const { id, data } = props != null ? props : {};
    return adminEditUser(id, data, requestOptions);
  };
  return __spreadValues({ mutationFn }, mutationOptions);
};
var useAdminEditUser = (options) => {
  const mutationOptions = getAdminEditUserMutationOptions(options);
  return useMutation4(mutationOptions);
};
var adminRoutingRegions = (options, signal) => {
  return customInstance(
    { url: `/admin/routing/region`, method: "GET", signal },
    options
  );
};
var getAdminRoutingRegionsQueryKey = () => {
  return [`/admin/routing/region`];
};
var getAdminRoutingRegionsQueryOptions = (options) => {
  var _a;
  const { query: queryOptions, request: requestOptions } = options != null ? options : {};
  const queryKey = (_a = queryOptions == null ? void 0 : queryOptions.queryKey) != null ? _a : getAdminRoutingRegionsQueryKey();
  const queryFn = ({ signal }) => adminRoutingRegions(requestOptions, signal);
  return __spreadValues({ queryKey, queryFn }, queryOptions);
};
function useAdminRoutingRegions(options) {
  const queryOptions = getAdminRoutingRegionsQueryOptions(options);
  const query = useQuery4(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var adminUpdateRoutingRegions = (openapiRoutingRegionsUpdateRequest, options) => {
  return customInstance(
    {
      url: `/admin/routing/region`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: openapiRoutingRegionsUpdateRequest
    },
    options
  );
};
var getAdminUpdateRoutingRegionsMutationOptions = (options) => {
  const mutationKey = ["adminUpdateRoutingRegions"];
  const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : __spreadProps(__spreadValues({}, options), { mutation: __spreadProps(__spreadValues({}, options.mutation), { mutationKey }) }) : { mutation: { mutationKey }, request: void 0 };
  const mutationFn = (props) => {
    const { data } = props != null ? props : {};
    return adminUpdateRoutingRegions(data, requestOptions);
  };
  return __spreadValues({ mutationFn }, mutationOptions);
};
var useAdminUpdateRoutingRegions = (options) => {
  const mutationOptions = getAdminUpdateRoutingRegionsMutationOptions(options);
  return useMutation4(mutationOptions);
};
var adminGetDiscount = (id, options, signal) => {
  return customInstance(
    { url: `/admin/discounts/${id}`, method: "GET", signal },
    options
  );
};
var getAdminGetDiscountQueryKey = (id) => {
  return [`/admin/discounts/${id}`];
};
var getAdminGetDiscountQueryOptions = (id, options) => {
  var _a;
  const { query: queryOptions, request: requestOptions } = options != null ? options : {};
  const queryKey = (_a = queryOptions == null ? void 0 : queryOptions.queryKey) != null ? _a : getAdminGetDiscountQueryKey(id);
  const queryFn = ({ signal }) => adminGetDiscount(id, requestOptions, signal);
  return __spreadValues({
    queryKey,
    queryFn,
    enabled: !!id
  }, queryOptions);
};
function useAdminGetDiscount(id, options) {
  const queryOptions = getAdminGetDiscountQueryOptions(id, options);
  const query = useQuery4(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var adminUpdateDiscount = (id, discountRequest, options) => {
  return customInstance(
    {
      url: `/admin/discounts/${id}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: discountRequest
    },
    options
  );
};
var getAdminUpdateDiscountMutationOptions = (options) => {
  const mutationKey = ["adminUpdateDiscount"];
  const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : __spreadProps(__spreadValues({}, options), { mutation: __spreadProps(__spreadValues({}, options.mutation), { mutationKey }) }) : { mutation: { mutationKey }, request: void 0 };
  const mutationFn = (props) => {
    const { id, data } = props != null ? props : {};
    return adminUpdateDiscount(id, data, requestOptions);
  };
  return __spreadValues({ mutationFn }, mutationOptions);
};
var useAdminUpdateDiscount = (options) => {
  const mutationOptions = getAdminUpdateDiscountMutationOptions(options);
  return useMutation4(mutationOptions);
};
var adminDeleteDiscount = (id, options) => {
  return customInstance(
    { url: `/admin/discounts/${id}`, method: "DELETE" },
    options
  );
};
var getAdminDeleteDiscountMutationOptions = (options) => {
  const mutationKey = ["adminDeleteDiscount"];
  const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : __spreadProps(__spreadValues({}, options), { mutation: __spreadProps(__spreadValues({}, options.mutation), { mutationKey }) }) : { mutation: { mutationKey }, request: void 0 };
  const mutationFn = (props) => {
    const { id } = props != null ? props : {};
    return adminDeleteDiscount(id, requestOptions);
  };
  return __spreadValues({ mutationFn }, mutationOptions);
};
var useAdminDeleteDiscount = (options) => {
  const mutationOptions = getAdminDeleteDiscountMutationOptions(options);
  return useMutation4(mutationOptions);
};
var adminCreateUser = (userCreateInternalRequest, options, signal) => {
  return customInstance(
    {
      url: `/admin/users`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: userCreateInternalRequest,
      signal
    },
    options
  );
};
var getAdminCreateUserMutationOptions = (options) => {
  const mutationKey = ["adminCreateUser"];
  const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : __spreadProps(__spreadValues({}, options), { mutation: __spreadProps(__spreadValues({}, options.mutation), { mutationKey }) }) : { mutation: { mutationKey }, request: void 0 };
  const mutationFn = (props) => {
    const { data } = props != null ? props : {};
    return adminCreateUser(data, requestOptions);
  };
  return __spreadValues({ mutationFn }, mutationOptions);
};
var useAdminCreateUser = (options) => {
  const mutationOptions = getAdminCreateUserMutationOptions(options);
  return useMutation4(mutationOptions);
};
var adminResendRegistrationEmail = (id, options, signal) => {
  return customInstance(
    {
      url: `/admin/users/${id}/resend-registration-mail`,
      method: "POST",
      signal
    },
    options
  );
};
var getAdminResendRegistrationEmailMutationOptions = (options) => {
  const mutationKey = ["adminResendRegistrationEmail"];
  const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : __spreadProps(__spreadValues({}, options), { mutation: __spreadProps(__spreadValues({}, options.mutation), { mutationKey }) }) : { mutation: { mutationKey }, request: void 0 };
  const mutationFn = (props) => {
    const { id } = props != null ? props : {};
    return adminResendRegistrationEmail(id, requestOptions);
  };
  return __spreadValues({ mutationFn }, mutationOptions);
};
var useAdminResendRegistrationEmail = (options) => {
  const mutationOptions = getAdminResendRegistrationEmailMutationOptions(options);
  return useMutation4(mutationOptions);
};
var adminResendForgotPasswordEmail = (id, options, signal) => {
  return customInstance(
    {
      url: `/admin/users/${id}/resend-forgot-password-mail`,
      method: "POST",
      signal
    },
    options
  );
};
var getAdminResendForgotPasswordEmailMutationOptions = (options) => {
  const mutationKey = ["adminResendForgotPasswordEmail"];
  const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : __spreadProps(__spreadValues({}, options), { mutation: __spreadProps(__spreadValues({}, options.mutation), { mutationKey }) }) : { mutation: { mutationKey }, request: void 0 };
  const mutationFn = (props) => {
    const { id } = props != null ? props : {};
    return adminResendForgotPasswordEmail(id, requestOptions);
  };
  return __spreadValues({ mutationFn }, mutationOptions);
};
var useAdminResendForgotPasswordEmail = (options) => {
  const mutationOptions = getAdminResendForgotPasswordEmailMutationOptions(options);
  return useMutation4(mutationOptions);
};
var adminSearchUsers = (userSearchAdmin, params, options, signal) => {
  return customInstance(
    {
      url: `/admin/search/users`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: userSearchAdmin,
      params,
      signal
    },
    options
  );
};
var getAdminSearchUsersMutationOptions = (options) => {
  const mutationKey = ["adminSearchUsers"];
  const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : __spreadProps(__spreadValues({}, options), { mutation: __spreadProps(__spreadValues({}, options.mutation), { mutationKey }) }) : { mutation: { mutationKey }, request: void 0 };
  const mutationFn = (props) => {
    const { data, params } = props != null ? props : {};
    return adminSearchUsers(data, params, requestOptions);
  };
  return __spreadValues({ mutationFn }, mutationOptions);
};
var useAdminSearchUsers = (options) => {
  const mutationOptions = getAdminSearchUsersMutationOptions(options);
  return useMutation4(mutationOptions);
};
var adminSearchProjects = (filterSearch, params, options, signal) => {
  return customInstance(
    {
      url: `/admin/search/projects`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: filterSearch,
      params,
      signal
    },
    options
  );
};
var getAdminSearchProjectsMutationOptions = (options) => {
  const mutationKey = ["adminSearchProjects"];
  const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : __spreadProps(__spreadValues({}, options), { mutation: __spreadProps(__spreadValues({}, options.mutation), { mutationKey }) }) : { mutation: { mutationKey }, request: void 0 };
  const mutationFn = (props) => {
    const { data, params } = props != null ? props : {};
    return adminSearchProjects(data, params, requestOptions);
  };
  return __spreadValues({ mutationFn }, mutationOptions);
};
var useAdminSearchProjects = (options) => {
  const mutationOptions = getAdminSearchProjectsMutationOptions(options);
  return useMutation4(mutationOptions);
};
var adminSearchDiscounts = (filterSearch, params, options, signal) => {
  return customInstance(
    {
      url: `/admin/search/discounts`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: filterSearch,
      params,
      signal
    },
    options
  );
};
var getAdminSearchDiscountsMutationOptions = (options) => {
  const mutationKey = ["adminSearchDiscounts"];
  const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : __spreadProps(__spreadValues({}, options), { mutation: __spreadProps(__spreadValues({}, options.mutation), { mutationKey }) }) : { mutation: { mutationKey }, request: void 0 };
  const mutationFn = (props) => {
    const { data, params } = props != null ? props : {};
    return adminSearchDiscounts(data, params, requestOptions);
  };
  return __spreadValues({ mutationFn }, mutationOptions);
};
var useAdminSearchDiscounts = (options) => {
  const mutationOptions = getAdminSearchDiscountsMutationOptions(options);
  return useMutation4(mutationOptions);
};
var adminSetDiscountEnabled = (id, discountEditRequest, options, signal) => {
  return customInstance(
    {
      url: `/admin/discounts/safe-edit/${id}`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: discountEditRequest,
      signal
    },
    options
  );
};
var getAdminSetDiscountEnabledMutationOptions = (options) => {
  const mutationKey = ["adminSetDiscountEnabled"];
  const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : __spreadProps(__spreadValues({}, options), { mutation: __spreadProps(__spreadValues({}, options.mutation), { mutationKey }) }) : { mutation: { mutationKey }, request: void 0 };
  const mutationFn = (props) => {
    const { id, data } = props != null ? props : {};
    return adminSetDiscountEnabled(id, data, requestOptions);
  };
  return __spreadValues({ mutationFn }, mutationOptions);
};
var useAdminSetDiscountEnabled = (options) => {
  const mutationOptions = getAdminSetDiscountEnabledMutationOptions(options);
  return useMutation4(mutationOptions);
};
var adminCreateDiscount = (discountRequest, options, signal) => {
  return customInstance(
    {
      url: `/admin/discounts/create`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: discountRequest,
      signal
    },
    options
  );
};
var getAdminCreateDiscountMutationOptions = (options) => {
  const mutationKey = ["adminCreateDiscount"];
  const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : __spreadProps(__spreadValues({}, options), { mutation: __spreadProps(__spreadValues({}, options.mutation), { mutationKey }) }) : { mutation: { mutationKey }, request: void 0 };
  const mutationFn = (props) => {
    const { data } = props != null ? props : {};
    return adminCreateDiscount(data, requestOptions);
  };
  return __spreadValues({ mutationFn }, mutationOptions);
};
var useAdminCreateDiscount = (options) => {
  const mutationOptions = getAdminCreateDiscountMutationOptions(options);
  return useMutation4(mutationOptions);
};
var adminQueryClusterTasks = (adminClusterTaskQueryRequest, options, signal) => {
  return customInstance(
    {
      url: `/admin/cluster-tasks/query`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: adminClusterTaskQueryRequest,
      signal
    },
    options
  );
};
var getAdminQueryClusterTasksMutationOptions = (options) => {
  const mutationKey = ["adminQueryClusterTasks"];
  const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : __spreadProps(__spreadValues({}, options), { mutation: __spreadProps(__spreadValues({}, options.mutation), { mutationKey }) }) : { mutation: { mutationKey }, request: void 0 };
  const mutationFn = (props) => {
    const { data } = props != null ? props : {};
    return adminQueryClusterTasks(data, requestOptions);
  };
  return __spreadValues({ mutationFn }, mutationOptions);
};
var useAdminQueryClusterTasks = (options) => {
  const mutationOptions = getAdminQueryClusterTasksMutationOptions(options);
  return useMutation4(mutationOptions);
};
var adminGetClusterTask = (adminClusterTaskGetRequest, options, signal) => {
  return customInstance(
    {
      url: `/admin/cluster-tasks/query/by-id`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: adminClusterTaskGetRequest,
      signal
    },
    options
  );
};
var getAdminGetClusterTaskMutationOptions = (options) => {
  const mutationKey = ["adminGetClusterTask"];
  const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : __spreadProps(__spreadValues({}, options), { mutation: __spreadProps(__spreadValues({}, options.mutation), { mutationKey }) }) : { mutation: { mutationKey }, request: void 0 };
  const mutationFn = (props) => {
    const { data } = props != null ? props : {};
    return adminGetClusterTask(data, requestOptions);
  };
  return __spreadValues({ mutationFn }, mutationOptions);
};
var useAdminGetClusterTask = (options) => {
  const mutationOptions = getAdminGetClusterTaskMutationOptions(options);
  return useMutation4(mutationOptions);
};
var adminGetProject = (id, options, signal) => {
  return customInstance(
    { url: `/admin/projects/${id}`, method: "GET", signal },
    options
  );
};
var getAdminGetProjectQueryKey = (id) => {
  return [`/admin/projects/${id}`];
};
var getAdminGetProjectQueryOptions = (id, options) => {
  var _a;
  const { query: queryOptions, request: requestOptions } = options != null ? options : {};
  const queryKey = (_a = queryOptions == null ? void 0 : queryOptions.queryKey) != null ? _a : getAdminGetProjectQueryKey(id);
  const queryFn = ({
    signal
  }) => adminGetProject(id, requestOptions, signal);
  return __spreadValues({
    queryKey,
    queryFn,
    enabled: !!id
  }, queryOptions);
};
function useAdminGetProject(id, options) {
  const queryOptions = getAdminGetProjectQueryOptions(id, options);
  const query = useQuery4(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var adminGetAdminPrinters = (params, options, signal) => {
  return customInstance(
    { url: `/admin/printer`, method: "GET", params, signal },
    options
  );
};
var getAdminGetAdminPrintersQueryKey = (params) => {
  return [`/admin/printer`, ...params ? [params] : []];
};
var getAdminGetAdminPrintersQueryOptions = (params, options) => {
  var _a;
  const { query: queryOptions, request: requestOptions } = options != null ? options : {};
  const queryKey = (_a = queryOptions == null ? void 0 : queryOptions.queryKey) != null ? _a : getAdminGetAdminPrintersQueryKey(params);
  const queryFn = ({ signal }) => adminGetAdminPrinters(params, requestOptions, signal);
  return __spreadValues({ queryKey, queryFn }, queryOptions);
};
function useAdminGetAdminPrinters(params, options) {
  const queryOptions = getAdminGetAdminPrintersQueryOptions(params, options);
  const query = useQuery4(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var adminListClusterTasks = (options, signal) => {
  return customInstance(
    { url: `/admin/docs/cluster-tasks`, method: "GET", signal },
    options
  );
};
var getAdminListClusterTasksQueryKey = () => {
  return [`/admin/docs/cluster-tasks`];
};
var getAdminListClusterTasksQueryOptions = (options) => {
  var _a;
  const { query: queryOptions, request: requestOptions } = options != null ? options : {};
  const queryKey = (_a = queryOptions == null ? void 0 : queryOptions.queryKey) != null ? _a : getAdminListClusterTasksQueryKey();
  const queryFn = ({ signal }) => adminListClusterTasks(requestOptions, signal);
  return __spreadValues({ queryKey, queryFn }, queryOptions);
};
function useAdminListClusterTasks(options) {
  const queryOptions = getAdminListClusterTasksQueryOptions(options);
  const query = useQuery4(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}

// src/services/cornerstone/generated/rest-checkout-controller-v-2/rest-checkout-controller-v-2.ts
import { useMutation as useMutation5 } from "@tanstack/react-query";
var placeOrder = (id, placeOrderRequest, options, signal) => {
  return customInstance(
    {
      url: `/v2/checkout/${id}/place-order`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: placeOrderRequest,
      signal
    },
    options
  );
};
var getPlaceOrderMutationOptions = (options) => {
  const mutationKey = ["placeOrder"];
  const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : __spreadProps(__spreadValues({}, options), { mutation: __spreadProps(__spreadValues({}, options.mutation), { mutationKey }) }) : { mutation: { mutationKey }, request: void 0 };
  const mutationFn = (props) => {
    const { id, data } = props != null ? props : {};
    return placeOrder(id, data, requestOptions);
  };
  return __spreadValues({ mutationFn }, mutationOptions);
};
var usePlaceOrder = (options) => {
  const mutationOptions = getPlaceOrderMutationOptions(options);
  return useMutation5(mutationOptions);
};
var updateCheckout = (checkoutId, checkoutUpdateRequest, options, signal) => {
  return customInstance(
    {
      url: `/v2/checkout/${checkoutId}/update`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: checkoutUpdateRequest,
      signal
    },
    options
  );
};
var getUpdateCheckoutMutationOptions = (options) => {
  const mutationKey = ["updateCheckout"];
  const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : __spreadProps(__spreadValues({}, options), { mutation: __spreadProps(__spreadValues({}, options.mutation), { mutationKey }) }) : { mutation: { mutationKey }, request: void 0 };
  const mutationFn = (props) => {
    const { checkoutId, data } = props != null ? props : {};
    return updateCheckout(checkoutId, data, requestOptions);
  };
  return __spreadValues({ mutationFn }, mutationOptions);
};
var useUpdateCheckout = (options) => {
  const mutationOptions = getUpdateCheckoutMutationOptions(options);
  return useMutation5(mutationOptions);
};
var createCheckoutV2 = (createCheckoutRequest, options, signal) => {
  return customInstance(
    {
      url: `/v2/checkout/v2`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createCheckoutRequest,
      signal
    },
    options
  );
};
var getCreateCheckoutV2MutationOptions = (options) => {
  const mutationKey = ["createCheckoutV2"];
  const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : __spreadProps(__spreadValues({}, options), { mutation: __spreadProps(__spreadValues({}, options.mutation), { mutationKey }) }) : { mutation: { mutationKey }, request: void 0 };
  const mutationFn = (props) => {
    const { data } = props != null ? props : {};
    return createCheckoutV2(data, requestOptions);
  };
  return __spreadValues({ mutationFn }, mutationOptions);
};
var useCreateCheckoutV2 = (options) => {
  const mutationOptions = getCreateCheckoutV2MutationOptions(options);
  return useMutation5(mutationOptions);
};
var createBraintreeClientToken = (options, signal) => {
  return customInstance(
    { url: `/v2/checkout/braintree-client-token`, method: "POST", signal },
    options
  );
};
var getCreateBraintreeClientTokenMutationOptions = (options) => {
  const mutationKey = ["createBraintreeClientToken"];
  const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : __spreadProps(__spreadValues({}, options), { mutation: __spreadProps(__spreadValues({}, options.mutation), { mutationKey }) }) : { mutation: { mutationKey }, request: void 0 };
  const mutationFn = () => {
    return createBraintreeClientToken(requestOptions);
  };
  return __spreadValues({ mutationFn }, mutationOptions);
};
var useCreateBraintreeClientToken = (options) => {
  const mutationOptions = getCreateBraintreeClientTokenMutationOptions(options);
  return useMutation5(mutationOptions);
};

// src/services/cornerstone/generated/rest-future-controller/rest-future-controller.ts
import { useMutation as useMutation6 } from "@tanstack/react-query";
var register = (authUserSignupRequest, options, signal) => {
  return customInstance(
    {
      url: `/v2/api/register`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: authUserSignupRequest,
      signal
    },
    options
  );
};
var getRegisterMutationOptions = (options) => {
  const mutationKey = ["register"];
  const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : __spreadProps(__spreadValues({}, options), { mutation: __spreadProps(__spreadValues({}, options.mutation), { mutationKey }) }) : { mutation: { mutationKey }, request: void 0 };
  const mutationFn = (props) => {
    const { data } = props != null ? props : {};
    return register(data, requestOptions);
  };
  return __spreadValues({ mutationFn }, mutationOptions);
};
var useRegister = (options) => {
  const mutationOptions = getRegisterMutationOptions(options);
  return useMutation6(mutationOptions);
};
var loginV2 = (authLoginRequestV2, options, signal) => {
  return customInstance(
    {
      url: `/v2/api/login`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: authLoginRequestV2,
      signal
    },
    options
  );
};
var getLoginV2MutationOptions = (options) => {
  const mutationKey = ["loginV2"];
  const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : __spreadProps(__spreadValues({}, options), { mutation: __spreadProps(__spreadValues({}, options.mutation), { mutationKey }) }) : { mutation: { mutationKey }, request: void 0 };
  const mutationFn = (props) => {
    const { data } = props != null ? props : {};
    return loginV2(data, requestOptions);
  };
  return __spreadValues({ mutationFn }, mutationOptions);
};
var useLoginV2 = (options) => {
  const mutationOptions = getLoginV2MutationOptions(options);
  return useMutation6(mutationOptions);
};

// src/services/cornerstone/generated/rest-test-resource-controller/rest-test-resource-controller.ts
import { useMutation as useMutation7 } from "@tanstack/react-query";
var createTestDiscount = (discountRequest, options, signal) => {
  return customInstance(
    {
      url: `/test-resources/create-discount`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: discountRequest,
      signal
    },
    options
  );
};
var getCreateTestDiscountMutationOptions = (options) => {
  const mutationKey = ["createTestDiscount"];
  const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : __spreadProps(__spreadValues({}, options), { mutation: __spreadProps(__spreadValues({}, options.mutation), { mutationKey }) }) : { mutation: { mutationKey }, request: void 0 };
  const mutationFn = (props) => {
    const { data } = props != null ? props : {};
    return createTestDiscount(data, requestOptions);
  };
  return __spreadValues({ mutationFn }, mutationOptions);
};
var useCreateTestDiscount = (options) => {
  const mutationOptions = getCreateTestDiscountMutationOptions(options);
  return useMutation7(mutationOptions);
};

// src/services/cornerstone/generated/rest-project-controller-v-2/rest-project-controller-v-2.ts
import { useMutation as useMutation8, useQuery as useQuery5 } from "@tanstack/react-query";
var getProjects2 = (options, signal) => {
  return customInstance(
    { url: `/projects`, method: "GET", signal },
    options
  );
};
var getGetProjectsQueryKey = () => {
  return [`/projects`];
};
var getGetProjectsQueryOptions = (options) => {
  var _a;
  const { query: queryOptions, request: requestOptions } = options != null ? options : {};
  const queryKey = (_a = queryOptions == null ? void 0 : queryOptions.queryKey) != null ? _a : getGetProjectsQueryKey();
  const queryFn = ({
    signal
  }) => getProjects2(requestOptions, signal);
  return __spreadValues({ queryKey, queryFn }, queryOptions);
};
function useGetProjects(options) {
  const queryOptions = getGetProjectsQueryOptions(options);
  const query = useQuery5(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var createProject = (projectCreateRequest, options, signal) => {
  return customInstance(
    {
      url: `/projects`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: projectCreateRequest,
      signal
    },
    options
  );
};
var getCreateProjectMutationOptions = (options) => {
  const mutationKey = ["createProject"];
  const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : __spreadProps(__spreadValues({}, options), { mutation: __spreadProps(__spreadValues({}, options.mutation), { mutationKey }) }) : { mutation: { mutationKey }, request: void 0 };
  const mutationFn = (props) => {
    const { data } = props != null ? props : {};
    return createProject(data, requestOptions);
  };
  return __spreadValues({ mutationFn }, mutationOptions);
};
var useCreateProject = (options) => {
  const mutationOptions = getCreateProjectMutationOptions(options);
  return useMutation8(mutationOptions);
};
var disableProject = (projectId, options, signal) => {
  return customInstance(
    { url: `/projects/${projectId}/disable`, method: "POST", signal },
    options
  );
};
var getDisableProjectMutationOptions = (options) => {
  const mutationKey = ["disableProject"];
  const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : __spreadProps(__spreadValues({}, options), { mutation: __spreadProps(__spreadValues({}, options.mutation), { mutationKey }) }) : { mutation: { mutationKey }, request: void 0 };
  const mutationFn = (props) => {
    const { projectId } = props != null ? props : {};
    return disableProject(projectId, requestOptions);
  };
  return __spreadValues({ mutationFn }, mutationOptions);
};
var useDisableProject = (options) => {
  const mutationOptions = getDisableProjectMutationOptions(options);
  return useMutation8(mutationOptions);
};
var createTestProject = (testProjectCreateRequest, options, signal) => {
  return customInstance(
    {
      url: `/projects/test-project`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: testProjectCreateRequest,
      signal
    },
    options
  );
};
var getCreateTestProjectMutationOptions = (options) => {
  const mutationKey = ["createTestProject"];
  const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : __spreadProps(__spreadValues({}, options), { mutation: __spreadProps(__spreadValues({}, options.mutation), { mutationKey }) }) : { mutation: { mutationKey }, request: void 0 };
  const mutationFn = (props) => {
    const { data } = props != null ? props : {};
    return createTestProject(data, requestOptions);
  };
  return __spreadValues({ mutationFn }, mutationOptions);
};
var useCreateTestProject = (options) => {
  const mutationOptions = getCreateTestProjectMutationOptions(options);
  return useMutation8(mutationOptions);
};
var getProject2 = (projectId, options, signal) => {
  return customInstance(
    { url: `/projects/${projectId}`, method: "GET", signal },
    options
  );
};
var getGetProjectQueryKey = (projectId) => {
  return [`/projects/${projectId}`];
};
var getGetProjectQueryOptions = (projectId, options) => {
  var _a;
  const { query: queryOptions, request: requestOptions } = options != null ? options : {};
  const queryKey = (_a = queryOptions == null ? void 0 : queryOptions.queryKey) != null ? _a : getGetProjectQueryKey(projectId);
  const queryFn = ({
    signal
  }) => getProject2(projectId, requestOptions, signal);
  return __spreadValues({
    queryKey,
    queryFn,
    enabled: !!projectId
  }, queryOptions);
};
function useGetProject(projectId, options) {
  const queryOptions = getGetProjectQueryOptions(projectId, options);
  const query = useQuery5(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}

// src/services/cornerstone/generated/rest-cart-controller/rest-cart-controller.ts
import { useMutation as useMutation9, useQuery as useQuery6 } from "@tanstack/react-query";
var updateQuantityV2 = (cartItemUpdateRequest, options, signal) => {
  return customInstance(
    {
      url: `/cart/v2/update-quantity`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: cartItemUpdateRequest,
      signal
    },
    options
  );
};
var getUpdateQuantityV2MutationOptions = (options) => {
  const mutationKey = ["updateQuantityV2"];
  const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : __spreadProps(__spreadValues({}, options), { mutation: __spreadProps(__spreadValues({}, options.mutation), { mutationKey }) }) : { mutation: { mutationKey }, request: void 0 };
  const mutationFn = (props) => {
    const { data } = props != null ? props : {};
    return updateQuantityV2(data, requestOptions);
  };
  return __spreadValues({ mutationFn }, mutationOptions);
};
var useUpdateQuantityV2 = (options) => {
  const mutationOptions = getUpdateQuantityV2MutationOptions(options);
  return useMutation9(mutationOptions);
};
var removeItemV2 = (cartItemDeleteRequest, options, signal) => {
  return customInstance(
    {
      url: `/cart/v2/remove-item`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: cartItemDeleteRequest,
      signal
    },
    options
  );
};
var getRemoveItemV2MutationOptions = (options) => {
  const mutationKey = ["removeItemV2"];
  const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : __spreadProps(__spreadValues({}, options), { mutation: __spreadProps(__spreadValues({}, options.mutation), { mutationKey }) }) : { mutation: { mutationKey }, request: void 0 };
  const mutationFn = (props) => {
    const { data } = props != null ? props : {};
    return removeItemV2(data, requestOptions);
  };
  return __spreadValues({ mutationFn }, mutationOptions);
};
var useRemoveItemV2 = (options) => {
  const mutationOptions = getRemoveItemV2MutationOptions(options);
  return useMutation9(mutationOptions);
};
var addItemV2 = (cartItemAddRequest, options, signal) => {
  return customInstance(
    {
      url: `/cart/v2/add-item`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: cartItemAddRequest,
      signal
    },
    options
  );
};
var getAddItemV2MutationOptions = (options) => {
  const mutationKey = ["addItemV2"];
  const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : __spreadProps(__spreadValues({}, options), { mutation: __spreadProps(__spreadValues({}, options.mutation), { mutationKey }) }) : { mutation: { mutationKey }, request: void 0 };
  const mutationFn = (props) => {
    const { data } = props != null ? props : {};
    return addItemV2(data, requestOptions);
  };
  return __spreadValues({ mutationFn }, mutationOptions);
};
var useAddItemV2 = (options) => {
  const mutationOptions = getAddItemV2MutationOptions(options);
  return useMutation9(mutationOptions);
};
var checkoutPreview = (checkoutPreviewRequest, options, signal) => {
  return customInstance(
    {
      url: `/cart/checkout-preview`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: checkoutPreviewRequest,
      signal
    },
    options
  );
};
var getCheckoutPreviewMutationOptions = (options) => {
  const mutationKey = ["checkoutPreview"];
  const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : __spreadProps(__spreadValues({}, options), { mutation: __spreadProps(__spreadValues({}, options.mutation), { mutationKey }) }) : { mutation: { mutationKey }, request: void 0 };
  const mutationFn = (props) => {
    const { data } = props != null ? props : {};
    return checkoutPreview(data, requestOptions);
  };
  return __spreadValues({ mutationFn }, mutationOptions);
};
var useCheckoutPreview = (options) => {
  const mutationOptions = getCheckoutPreviewMutationOptions(options);
  return useMutation9(mutationOptions);
};
var getCartV2 = (options, signal) => {
  return customInstance(
    { url: `/cart/v2`, method: "GET", signal },
    options
  );
};
var getGetCartV2QueryKey = () => {
  return [`/cart/v2`];
};
var getGetCartV2QueryOptions = (options) => {
  var _a;
  const { query: queryOptions, request: requestOptions } = options != null ? options : {};
  const queryKey = (_a = queryOptions == null ? void 0 : queryOptions.queryKey) != null ? _a : getGetCartV2QueryKey();
  const queryFn = ({
    signal
  }) => getCartV2(requestOptions, signal);
  return __spreadValues({ queryKey, queryFn }, queryOptions);
};
function useGetCartV2(options) {
  const queryOptions = getGetCartV2QueryOptions(options);
  const query = useQuery6(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var getVolumeDiscounts = (options, signal) => {
  return customInstance(
    { url: `/cart/v2/volume-discounts`, method: "GET", signal },
    options
  );
};
var getGetVolumeDiscountsQueryKey = () => {
  return [`/cart/v2/volume-discounts`];
};
var getGetVolumeDiscountsQueryOptions = (options) => {
  var _a;
  const { query: queryOptions, request: requestOptions } = options != null ? options : {};
  const queryKey = (_a = queryOptions == null ? void 0 : queryOptions.queryKey) != null ? _a : getGetVolumeDiscountsQueryKey();
  const queryFn = ({ signal }) => getVolumeDiscounts(requestOptions, signal);
  return __spreadValues({ queryKey, queryFn }, queryOptions);
};
function useGetVolumeDiscounts(options) {
  const queryOptions = getGetVolumeDiscountsQueryOptions(options);
  const query = useQuery6(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var clearCart = (options) => {
  return customInstance({ url: `/cart`, method: "DELETE" }, options);
};
var getClearCartMutationOptions = (options) => {
  const mutationKey = ["clearCart"];
  const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : __spreadProps(__spreadValues({}, options), { mutation: __spreadProps(__spreadValues({}, options.mutation), { mutationKey }) }) : { mutation: { mutationKey }, request: void 0 };
  const mutationFn = () => {
    return clearCart(requestOptions);
  };
  return __spreadValues({ mutationFn }, mutationOptions);
};
var useClearCart = (options) => {
  const mutationOptions = getClearCartMutationOptions(options);
  return useMutation9(mutationOptions);
};

// src/services/cornerstone/generated/rest-auth-controller/rest-auth-controller.ts
import { useMutation as useMutation10 } from "@tanstack/react-query";
var testUser = (authTestUserRequest, options, signal) => {
  return customInstance(
    {
      url: `/auth/test-user`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: authTestUserRequest,
      signal
    },
    options
  );
};
var getTestUserMutationOptions = (options) => {
  const mutationKey = ["testUser"];
  const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : __spreadProps(__spreadValues({}, options), { mutation: __spreadProps(__spreadValues({}, options.mutation), { mutationKey }) }) : { mutation: { mutationKey }, request: void 0 };
  const mutationFn = (props) => {
    const { data } = props != null ? props : {};
    return testUser(data, requestOptions);
  };
  return __spreadValues({ mutationFn }, mutationOptions);
};
var useTestUser = (options) => {
  const mutationOptions = getTestUserMutationOptions(options);
  return useMutation10(mutationOptions);
};
var signUp = (authUserSignupRequest, options, signal) => {
  return customInstance(
    {
      url: `/auth/signup`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: authUserSignupRequest,
      signal
    },
    options
  );
};
var getSignUpMutationOptions = (options) => {
  const mutationKey = ["signUp"];
  const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : __spreadProps(__spreadValues({}, options), { mutation: __spreadProps(__spreadValues({}, options.mutation), { mutationKey }) }) : { mutation: { mutationKey }, request: void 0 };
  const mutationFn = (props) => {
    const { data } = props != null ? props : {};
    return signUp(data, requestOptions);
  };
  return __spreadValues({ mutationFn }, mutationOptions);
};
var useSignUp = (options) => {
  const mutationOptions = getSignUpMutationOptions(options);
  return useMutation10(mutationOptions);
};
var requestRegistrationToken = (authRegistrationTokenRequest, options, signal) => {
  return customInstance(
    {
      url: `/auth/signup/request-registration-token`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: authRegistrationTokenRequest,
      signal
    },
    options
  );
};
var getRequestRegistrationTokenMutationOptions = (options) => {
  const mutationKey = ["requestRegistrationToken"];
  const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : __spreadProps(__spreadValues({}, options), { mutation: __spreadProps(__spreadValues({}, options.mutation), { mutationKey }) }) : { mutation: { mutationKey }, request: void 0 };
  const mutationFn = (props) => {
    const { data } = props != null ? props : {};
    return requestRegistrationToken(data, requestOptions);
  };
  return __spreadValues({ mutationFn }, mutationOptions);
};
var useRequestRegistrationToken = (options) => {
  const mutationOptions = getRequestRegistrationTokenMutationOptions(options);
  return useMutation10(mutationOptions);
};
var confirmSignupRegistration = (confirmationToken, options, signal) => {
  return customInstance(
    {
      url: `/auth/signup/confirm-registration/${confirmationToken}`,
      method: "POST",
      signal
    },
    options
  );
};
var getConfirmSignupRegistrationMutationOptions = (options) => {
  const mutationKey = ["confirmSignupRegistration"];
  const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : __spreadProps(__spreadValues({}, options), { mutation: __spreadProps(__spreadValues({}, options.mutation), { mutationKey }) }) : { mutation: { mutationKey }, request: void 0 };
  const mutationFn = (props) => {
    const { confirmationToken } = props != null ? props : {};
    return confirmSignupRegistration(confirmationToken, requestOptions);
  };
  return __spreadValues({ mutationFn }, mutationOptions);
};
var useConfirmSignupRegistration = (options) => {
  const mutationOptions = getConfirmSignupRegistrationMutationOptions(options);
  return useMutation10(mutationOptions);
};
var refreshToken = (options, signal) => {
  return customInstance(
    { url: `/auth/refresh-token`, method: "POST", signal },
    options
  );
};
var getRefreshTokenMutationOptions = (options) => {
  const mutationKey = ["refreshToken"];
  const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : __spreadProps(__spreadValues({}, options), { mutation: __spreadProps(__spreadValues({}, options.mutation), { mutationKey }) }) : { mutation: { mutationKey }, request: void 0 };
  const mutationFn = () => {
    return refreshToken(requestOptions);
  };
  return __spreadValues({ mutationFn }, mutationOptions);
};
var useRefreshToken = (options) => {
  const mutationOptions = getRefreshTokenMutationOptions(options);
  return useMutation10(mutationOptions);
};
var logout = (options, signal) => {
  return customInstance(
    { url: `/auth/logout`, method: "POST", signal },
    options
  );
};
var getLogoutMutationOptions = (options) => {
  const mutationKey = ["logout"];
  const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : __spreadProps(__spreadValues({}, options), { mutation: __spreadProps(__spreadValues({}, options.mutation), { mutationKey }) }) : { mutation: { mutationKey }, request: void 0 };
  const mutationFn = () => {
    return logout(requestOptions);
  };
  return __spreadValues({ mutationFn }, mutationOptions);
};
var useLogout = (options) => {
  const mutationOptions = getLogoutMutationOptions(options);
  return useMutation10(mutationOptions);
};
var login = (authLoginRequest, options, signal) => {
  return customInstance(
    {
      url: `/auth/login`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: authLoginRequest,
      signal
    },
    options
  );
};
var getLoginMutationOptions = (options) => {
  const mutationKey = ["login"];
  const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : __spreadProps(__spreadValues({}, options), { mutation: __spreadProps(__spreadValues({}, options.mutation), { mutationKey }) }) : { mutation: { mutationKey }, request: void 0 };
  const mutationFn = (props) => {
    const { data } = props != null ? props : {};
    return login(data, requestOptions);
  };
  return __spreadValues({ mutationFn }, mutationOptions);
};
var useLogin = (options) => {
  const mutationOptions = getLoginMutationOptions(options);
  return useMutation10(mutationOptions);
};
var forgotPassword = (authForgotPasswordRequest, options, signal) => {
  return customInstance(
    {
      url: `/auth/forgot-password`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: authForgotPasswordRequest,
      signal
    },
    options
  );
};
var getForgotPasswordMutationOptions = (options) => {
  const mutationKey = ["forgotPassword"];
  const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : __spreadProps(__spreadValues({}, options), { mutation: __spreadProps(__spreadValues({}, options.mutation), { mutationKey }) }) : { mutation: { mutationKey }, request: void 0 };
  const mutationFn = (props) => {
    const { data } = props != null ? props : {};
    return forgotPassword(data, requestOptions);
  };
  return __spreadValues({ mutationFn }, mutationOptions);
};
var useForgotPassword = (options) => {
  const mutationOptions = getForgotPasswordMutationOptions(options);
  return useMutation10(mutationOptions);
};
var confirmForgotPassword = (authForgotPasswordConfirmRequest, options, signal) => {
  return customInstance(
    {
      url: `/auth/forgot-password/confirm-forgot-password`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: authForgotPasswordConfirmRequest,
      signal
    },
    options
  );
};
var getConfirmForgotPasswordMutationOptions = (options) => {
  const mutationKey = ["confirmForgotPassword"];
  const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : __spreadProps(__spreadValues({}, options), { mutation: __spreadProps(__spreadValues({}, options.mutation), { mutationKey }) }) : { mutation: { mutationKey }, request: void 0 };
  const mutationFn = (props) => {
    const { data } = props != null ? props : {};
    return confirmForgotPassword(data, requestOptions);
  };
  return __spreadValues({ mutationFn }, mutationOptions);
};
var useConfirmForgotPassword = (options) => {
  const mutationOptions = getConfirmForgotPasswordMutationOptions(options);
  return useMutation10(mutationOptions);
};

// src/services/cornerstone/generated/rest-addresses-controller/rest-addresses-controller.ts
import { useMutation as useMutation11, useQuery as useQuery7 } from "@tanstack/react-query";
var getUserAddresses = (options, signal) => {
  return customInstance(
    { url: `/addresses`, method: "GET", signal },
    options
  );
};
var getGetUserAddressesQueryKey = () => {
  return [`/addresses`];
};
var getGetUserAddressesQueryOptions = (options) => {
  var _a;
  const { query: queryOptions, request: requestOptions } = options != null ? options : {};
  const queryKey = (_a = queryOptions == null ? void 0 : queryOptions.queryKey) != null ? _a : getGetUserAddressesQueryKey();
  const queryFn = ({ signal }) => getUserAddresses(requestOptions, signal);
  return __spreadValues({ queryKey, queryFn }, queryOptions);
};
function useGetUserAddresses(options) {
  const queryOptions = getGetUserAddressesQueryOptions(options);
  const query = useQuery7(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var addAddress = (valueAddress, options, signal) => {
  return customInstance(
    {
      url: `/addresses`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: valueAddress,
      signal
    },
    options
  );
};
var getAddAddressMutationOptions = (options) => {
  const mutationKey = ["addAddress"];
  const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : __spreadProps(__spreadValues({}, options), { mutation: __spreadProps(__spreadValues({}, options.mutation), { mutationKey }) }) : { mutation: { mutationKey }, request: void 0 };
  const mutationFn = (props) => {
    const { data } = props != null ? props : {};
    return addAddress(data, requestOptions);
  };
  return __spreadValues({ mutationFn }, mutationOptions);
};
var useAddAddress = (options) => {
  const mutationOptions = getAddAddressMutationOptions(options);
  return useMutation11(mutationOptions);
};
var getAddress = (addressId, options, signal) => {
  return customInstance(
    { url: `/addresses/${addressId}`, method: "GET", signal },
    options
  );
};
var getGetAddressQueryKey = (addressId) => {
  return [`/addresses/${addressId}`];
};
var getGetAddressQueryOptions = (addressId, options) => {
  var _a;
  const { query: queryOptions, request: requestOptions } = options != null ? options : {};
  const queryKey = (_a = queryOptions == null ? void 0 : queryOptions.queryKey) != null ? _a : getGetAddressQueryKey(addressId);
  const queryFn = ({
    signal
  }) => getAddress(addressId, requestOptions, signal);
  return __spreadValues({
    queryKey,
    queryFn,
    enabled: !!addressId
  }, queryOptions);
};
function useGetAddress(addressId, options) {
  const queryOptions = getGetAddressQueryOptions(addressId, options);
  const query = useQuery7(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var updateAddress = (addressId, valueAddress, options, signal) => {
  return customInstance(
    {
      url: `/addresses/${addressId}`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: valueAddress,
      signal
    },
    options
  );
};
var getUpdateAddressMutationOptions = (options) => {
  const mutationKey = ["updateAddress"];
  const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : __spreadProps(__spreadValues({}, options), { mutation: __spreadProps(__spreadValues({}, options.mutation), { mutationKey }) }) : { mutation: { mutationKey }, request: void 0 };
  const mutationFn = (props) => {
    const { addressId, data } = props != null ? props : {};
    return updateAddress(addressId, data, requestOptions);
  };
  return __spreadValues({ mutationFn }, mutationOptions);
};
var useUpdateAddress = (options) => {
  const mutationOptions = getUpdateAddressMutationOptions(options);
  return useMutation11(mutationOptions);
};
var deleteAddress = (addressId, options, signal) => {
  return customInstance(
    { url: `/addresses/${addressId}/delete`, method: "POST", signal },
    options
  );
};
var getDeleteAddressMutationOptions = (options) => {
  const mutationKey = ["deleteAddress"];
  const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : __spreadProps(__spreadValues({}, options), { mutation: __spreadProps(__spreadValues({}, options.mutation), { mutationKey }) }) : { mutation: { mutationKey }, request: void 0 };
  const mutationFn = (props) => {
    const { addressId } = props != null ? props : {};
    return deleteAddress(addressId, requestOptions);
  };
  return __spreadValues({ mutationFn }, mutationOptions);
};
var useDeleteAddress = (options) => {
  const mutationOptions = getDeleteAddressMutationOptions(options);
  return useMutation11(mutationOptions);
};

// src/services/cornerstone/generated/rest-products-controller-v-2/rest-products-controller-v-2.ts
import { useQuery as useQuery8 } from "@tanstack/react-query";
var getProductSpecifications = (options, signal) => {
  return customInstance(
    { url: `/v2/products/specifications`, method: "GET", signal },
    options
  );
};
var getGetProductSpecificationsQueryKey = () => {
  return [`/v2/products/specifications`];
};
var getGetProductSpecificationsQueryOptions = (options) => {
  var _a;
  const { query: queryOptions, request: requestOptions } = options != null ? options : {};
  const queryKey = (_a = queryOptions == null ? void 0 : queryOptions.queryKey) != null ? _a : getGetProductSpecificationsQueryKey();
  const queryFn = ({ signal }) => getProductSpecifications(requestOptions, signal);
  return __spreadValues({ queryKey, queryFn }, queryOptions);
};
function useGetProductSpecifications(options) {
  const queryOptions = getGetProductSpecificationsQueryOptions(options);
  const query = useQuery8(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var getProductRules = (options, signal) => {
  return customInstance(
    { url: `/v2/products/rules`, method: "GET", signal },
    options
  );
};
var getGetProductRulesQueryKey = () => {
  return [`/v2/products/rules`];
};
var getGetProductRulesQueryOptions = (options) => {
  var _a;
  const { query: queryOptions, request: requestOptions } = options != null ? options : {};
  const queryKey = (_a = queryOptions == null ? void 0 : queryOptions.queryKey) != null ? _a : getGetProductRulesQueryKey();
  const queryFn = ({
    signal
  }) => getProductRules(requestOptions, signal);
  return __spreadValues({ queryKey, queryFn }, queryOptions);
};
function useGetProductRules(options) {
  const queryOptions = getGetProductRulesQueryOptions(options);
  const query = useQuery8(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var getPricingRules = (params, options, signal) => {
  return customInstance(
    { url: `/v2/products/prices`, method: "GET", params, signal },
    options
  );
};
var getGetPricingRulesQueryKey = (params) => {
  return [`/v2/products/prices`, ...params ? [params] : []];
};
var getGetPricingRulesQueryOptions = (params, options) => {
  var _a;
  const { query: queryOptions, request: requestOptions } = options != null ? options : {};
  const queryKey = (_a = queryOptions == null ? void 0 : queryOptions.queryKey) != null ? _a : getGetPricingRulesQueryKey(params);
  const queryFn = ({
    signal
  }) => getPricingRules(params, requestOptions, signal);
  return __spreadValues({ queryKey, queryFn }, queryOptions);
};
function useGetPricingRules(params, options) {
  const queryOptions = getGetPricingRulesQueryOptions(params, options);
  const query = useQuery8(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}

// src/services/cornerstone/generated/rest-health-controller/rest-health-controller.ts
import { useQuery as useQuery9 } from "@tanstack/react-query";
var health = (options, signal) => {
  return customInstance(
    { url: `/health`, method: "GET", signal },
    options
  );
};
var getHealthQueryKey = () => {
  return [`/health`];
};
var getHealthQueryOptions = (options) => {
  var _a;
  const { query: queryOptions, request: requestOptions } = options != null ? options : {};
  const queryKey = (_a = queryOptions == null ? void 0 : queryOptions.queryKey) != null ? _a : getHealthQueryKey();
  const queryFn = ({
    signal
  }) => health(requestOptions, signal);
  return __spreadValues({ queryKey, queryFn }, queryOptions);
};
function useHealth(options) {
  const queryOptions = getHealthQueryOptions(options);
  const query = useQuery9(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var privateClientsHealth = (options, signal) => {
  return customInstance(
    { url: `/health/private-clients`, method: "GET", signal },
    options
  );
};
var getPrivateClientsHealthQueryKey = () => {
  return [`/health/private-clients`];
};
var getPrivateClientsHealthQueryOptions = (options) => {
  var _a;
  const { query: queryOptions, request: requestOptions } = options != null ? options : {};
  const queryKey = (_a = queryOptions == null ? void 0 : queryOptions.queryKey) != null ? _a : getPrivateClientsHealthQueryKey();
  const queryFn = ({ signal }) => privateClientsHealth(requestOptions, signal);
  return __spreadValues({ queryKey, queryFn }, queryOptions);
};
function usePrivateClientsHealth(options) {
  const queryOptions = getPrivateClientsHealthQueryOptions(options);
  const query = useQuery9(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var ping = (options, signal) => {
  return customInstance(
    { url: `/health/ping`, method: "GET", signal },
    options
  );
};
var getPingQueryKey = () => {
  return [`/health/ping`];
};
var getPingQueryOptions = (options) => {
  var _a;
  const { query: queryOptions, request: requestOptions } = options != null ? options : {};
  const queryKey = (_a = queryOptions == null ? void 0 : queryOptions.queryKey) != null ? _a : getPingQueryKey();
  const queryFn = ({
    signal
  }) => ping(requestOptions, signal);
  return __spreadValues({ queryKey, queryFn }, queryOptions);
};
function usePing(options) {
  const queryOptions = getPingQueryOptions(options);
  const query = useQuery9(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}

// src/services/cornerstone/generated/rest-constants-controller/rest-constants-controller.ts
import { useQuery as useQuery10 } from "@tanstack/react-query";
var getConstants = (options, signal) => {
  return customInstance(
    { url: `/constants`, method: "GET", signal },
    options
  );
};
var getGetConstantsQueryKey = () => {
  return [`/constants`];
};
var getGetConstantsQueryOptions = (options) => {
  var _a;
  const { query: queryOptions, request: requestOptions } = options != null ? options : {};
  const queryKey = (_a = queryOptions == null ? void 0 : queryOptions.queryKey) != null ? _a : getGetConstantsQueryKey();
  const queryFn = ({
    signal
  }) => getConstants(requestOptions, signal);
  return __spreadValues({ queryKey, queryFn }, queryOptions);
};
function useGetConstants(options) {
  const queryOptions = getGetConstantsQueryOptions(options);
  const query = useQuery10(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}

// src/services/cornerstone/generated/model/_authGroupSearchFieldsAllowedSortsItem.ts
var _AuthGroupSearchFieldsAllowedSortsItem = {
  id: "id",
  name: "name",
  createdAt: "createdAt",
  updatedAt: "updatedAt"
};

// src/services/cornerstone/generated/model/_discountSearchFieldsAllowedSortsItem.ts
var _DiscountSearchFieldsAllowedSortsItem = {
  id: "id",
  discountCode: "discountCode",
  discountApplicationMode: "discountApplicationMode"
};

// src/services/cornerstone/generated/model/_projectSearchFieldsAllowedSortsItem.ts
var _ProjectSearchFieldsAllowedSortsItem = {
  id: "id",
  status: "status",
  title: "title",
  projectType: "projectType",
  createdAt: "createdAt",
  updatedAt: "updatedAt"
};

// src/services/cornerstone/generated/model/_transactionSearchFieldsAllowedSortsItem.ts
var _TransactionSearchFieldsAllowedSortsItem = {
  id: "id",
  orderId: "orderId",
  braintreeTransactionId: "braintreeTransactionId",
  status: "status",
  transactionType: "transactionType",
  amount: "amount",
  currency: "currency",
  paymentMethodDesc: "paymentMethodDesc",
  createdAt: "createdAt",
  updatedAt: "updatedAt"
};

// src/services/cornerstone/generated/model/_userSearchFieldsAllowedSortsItem.ts
var _UserSearchFieldsAllowedSortsItem = {
  id: "id",
  blurbyUsername: "blurbyUsername",
  userPublicId: "userPublicId",
  email: "email",
  firstName: "firstName",
  lastName: "lastName",
  authGroupId: "authGroupId",
  createdAt: "createdAt",
  updatedAt: "updatedAt"
};

// src/services/cornerstone/generated/model/authAuthority.ts
var AuthAuthority = {
  NUMBER_10: "10",
  NUMBER_50: "50",
  NUMBER_51: "51",
  NUMBER_100: "100",
  NUMBER_150: "150",
  NUMBER_200: "200",
  NUMBER_300: "300",
  NUMBER_350: "350",
  NUMBER_400: "400",
  NUMBER_401: "401",
  NUMBER_450: "450",
  NUMBER_451: "451",
  NUMBER_500: "500",
  NUMBER_550: "550",
  NUMBER_600: "600",
  NUMBER_650: "650",
  NUMBER_700: "700",
  NUMBER_750: "750"
};

// src/services/cornerstone/generated/model/country.ts
var Country = {
  AF: "AF",
  AX: "AX",
  AL: "AL",
  DZ: "DZ",
  AS: "AS",
  AD: "AD",
  AO: "AO",
  AI: "AI",
  AQ: "AQ",
  AG: "AG",
  AR: "AR",
  AM: "AM",
  AW: "AW",
  AU: "AU",
  AT: "AT",
  AZ: "AZ",
  BS: "BS",
  BH: "BH",
  BD: "BD",
  BB: "BB",
  BY: "BY",
  BE: "BE",
  BZ: "BZ",
  BJ: "BJ",
  BM: "BM",
  BT: "BT",
  BO: "BO",
  BQ: "BQ",
  BA: "BA",
  BW: "BW",
  BV: "BV",
  BR: "BR",
  IO: "IO",
  BN: "BN",
  BG: "BG",
  BF: "BF",
  BI: "BI",
  CV: "CV",
  KH: "KH",
  CM: "CM",
  CA: "CA",
  KY: "KY",
  CF: "CF",
  TD: "TD",
  CL: "CL",
  CN: "CN",
  CX: "CX",
  CC: "CC",
  CO: "CO",
  KM: "KM",
  CD: "CD",
  CG: "CG",
  CK: "CK",
  CR: "CR",
  CI: "CI",
  HR: "HR",
  CU: "CU",
  CW: "CW",
  CY: "CY",
  CZ: "CZ",
  DK: "DK",
  DJ: "DJ",
  DM: "DM",
  DO: "DO",
  EC: "EC",
  EG: "EG",
  SV: "SV",
  GQ: "GQ",
  ER: "ER",
  EE: "EE",
  SZ: "SZ",
  ET: "ET",
  FK: "FK",
  FO: "FO",
  FJ: "FJ",
  FI: "FI",
  FR: "FR",
  GF: "GF",
  PF: "PF",
  TF: "TF",
  GA: "GA",
  GM: "GM",
  GE: "GE",
  DE: "DE",
  GH: "GH",
  GI: "GI",
  GR: "GR",
  GL: "GL",
  GD: "GD",
  GP: "GP",
  GU: "GU",
  GT: "GT",
  GG: "GG",
  GN: "GN",
  GW: "GW",
  GY: "GY",
  HT: "HT",
  HM: "HM",
  VA: "VA",
  HN: "HN",
  HK: "HK",
  HU: "HU",
  IS: "IS",
  IN: "IN",
  ID: "ID",
  IR: "IR",
  IQ: "IQ",
  IE: "IE",
  IM: "IM",
  IL: "IL",
  IT: "IT",
  JM: "JM",
  JP: "JP",
  JE: "JE",
  JO: "JO",
  KZ: "KZ",
  KE: "KE",
  KI: "KI",
  KP: "KP",
  KR: "KR",
  KW: "KW",
  KG: "KG",
  LA: "LA",
  LV: "LV",
  LB: "LB",
  LS: "LS",
  LR: "LR",
  LY: "LY",
  LI: "LI",
  LT: "LT",
  LU: "LU",
  MO: "MO",
  MK: "MK",
  MG: "MG",
  MW: "MW",
  MY: "MY",
  MV: "MV",
  ML: "ML",
  MT: "MT",
  MH: "MH",
  MQ: "MQ",
  MR: "MR",
  MU: "MU",
  YT: "YT",
  MX: "MX",
  FM: "FM",
  MD: "MD",
  MC: "MC",
  MN: "MN",
  ME: "ME",
  MS: "MS",
  MA: "MA",
  MZ: "MZ",
  MM: "MM",
  NA: "NA",
  NR: "NR",
  NP: "NP",
  NL: "NL",
  NC: "NC",
  NZ: "NZ",
  NI: "NI",
  NE: "NE",
  NG: "NG",
  NU: "NU",
  NF: "NF",
  MP: "MP",
  NO: "NO",
  OM: "OM",
  PK: "PK",
  PW: "PW",
  PS: "PS",
  PA: "PA",
  PG: "PG",
  PY: "PY",
  PE: "PE",
  PH: "PH",
  PN: "PN",
  PL: "PL",
  PT: "PT",
  PR: "PR",
  QA: "QA",
  RE: "RE",
  RO: "RO",
  RU: "RU",
  RW: "RW",
  BL: "BL",
  SH: "SH",
  KN: "KN",
  LC: "LC",
  MF: "MF",
  PM: "PM",
  VC: "VC",
  WS: "WS",
  SM: "SM",
  ST: "ST",
  SA: "SA",
  SN: "SN",
  RS: "RS",
  SC: "SC",
  SL: "SL",
  SG: "SG",
  SX: "SX",
  SK: "SK",
  SI: "SI",
  SB: "SB",
  SO: "SO",
  ZA: "ZA",
  GS: "GS",
  SS: "SS",
  ES: "ES",
  LK: "LK",
  SD: "SD",
  SR: "SR",
  SJ: "SJ",
  SE: "SE",
  CH: "CH",
  SY: "SY",
  TW: "TW",
  TJ: "TJ",
  TZ: "TZ",
  TH: "TH",
  TL: "TL",
  TG: "TG",
  TK: "TK",
  TO: "TO",
  TT: "TT",
  TN: "TN",
  TR: "TR",
  TM: "TM",
  TC: "TC",
  TV: "TV",
  UG: "UG",
  UA: "UA",
  AE: "AE",
  GB: "GB",
  UM: "UM",
  US: "US",
  UY: "UY",
  UZ: "UZ",
  VU: "VU",
  VE: "VE",
  VN: "VN",
  VG: "VG",
  VI: "VI",
  WF: "WF",
  EH: "EH",
  YE: "YE",
  ZM: "ZM",
  ZW: "ZW"
};

// src/services/cornerstone/generated/model/coverPagesType.ts
var CoverPagesType = {
  OUTSIDE_ONLY: "OUTSIDE_ONLY",
  INSIDE_AND_OUTSIDE: "INSIDE_AND_OUTSIDE"
};

// src/services/cornerstone/generated/model/coverRule.ts
var CoverRule = {
  SOFTCOVER: "SOFTCOVER",
  IMAGEWRAP: "IMAGEWRAP",
  DUSTJACKET: "DUSTJACKET"
};

// src/services/cornerstone/generated/model/direction.ts
var Direction = {
  ASC: "ASC",
  DESC: "DESC"
};

// src/services/cornerstone/generated/model/discountApplicationMode.ts
var DiscountApplicationMode = {
  AUTOMATIC: "AUTOMATIC",
  BULK: "BULK",
  COUPON: "COUPON"
};

// src/services/cornerstone/generated/model/discountTarget.ts
var DiscountTarget = {
  UNIT: "UNIT",
  SHIPPING: "SHIPPING",
  ORDER: "ORDER",
  PRICING_RULE: "PRICING_RULE"
};

// src/services/cornerstone/generated/model/errorCode.ts
var ErrorCode = {
  INTERNAL_ERROR: "INTERNAL_ERROR",
  DEPENDENCY_ERROR: "DEPENDENCY_ERROR",
  DATABASE_WRITE_FAILED: "DATABASE_WRITE_FAILED",
  NOT_FOUND: "NOT_FOUND",
  BAD_SEARCH_CONDITION: "BAD_SEARCH_CONDITION",
  COUNTRY_INVALID: "COUNTRY_INVALID",
  REGION_INVALID: "REGION_INVALID",
  AVALARA_VALIDATION_FAILED: "AVALARA_VALIDATION_FAILED",
  MISSING_2_STEP_REGISTRATION_CONFIRMATION: "MISSING_2_STEP_REGISTRATION_CONFIRMATION",
  USER_ALREADY_EXISTS: "USER_ALREADY_EXISTS",
  USER_REGISTRATION_TOKEN_NOT_FOUND: "USER_REGISTRATION_TOKEN_NOT_FOUND",
  FORGOT_PASSWORD_VALIDATION: "FORGOT_PASSWORD_VALIDATION",
  USER_ALREADY_REGISTERED: "USER_ALREADY_REGISTERED",
  EMAIL_DOMAIN_BANNED: "EMAIL_DOMAIN_BANNED",
  BAD_CREDENTIALS: "BAD_CREDENTIALS",
  LINE_ITEM_NOT_FOUND: "LINE_ITEM_NOT_FOUND",
  PROJECT_NOT_FOUND: "PROJECT_NOT_FOUND",
  SKU_IS_NOT_VALID: "SKU_IS_NOT_VALID",
  SKU_IS_NOT_VALID_FOR_PROJECT: "SKU_IS_NOT_VALID_FOR_PROJECT",
  INVALID_QUANTITY: "INVALID_QUANTITY",
  BRAINTREE_CUSTOMER_NOT_FOUND: "BRAINTREE_CUSTOMER_NOT_FOUND",
  BRAINTREE_TOKEN_FAILED: "BRAINTREE_TOKEN_FAILED",
  BRAINTREE_TRANSACTION_CREATION_FAILED: "BRAINTREE_TRANSACTION_CREATION_FAILED",
  DISCOUNT_NOT_FOUND: "DISCOUNT_NOT_FOUND",
  DISCOUNT_MUST_BE_COUPON: "DISCOUNT_MUST_BE_COUPON",
  DISCOUNT_IN_USE: "DISCOUNT_IN_USE",
  DISCOUNT_DATES_OUT_OF_RANGE: "DISCOUNT_DATES_OUT_OF_RANGE",
  NO_SUPPORTED_SKUS_IN_CART: "NO_SUPPORTED_SKUS_IN_CART",
  CART_DOES_NOT_QUALIFY: "CART_DOES_NOT_QUALIFY",
  NOT_YET_VALID: "NOT_YET_VALID",
  NO_LONGER_VALID: "NO_LONGER_VALID",
  CURRENCY_NOT_SUPPORTED: "CURRENCY_NOT_SUPPORTED",
  USAGE_LIMIT_REACHED: "USAGE_LIMIT_REACHED",
  TAX_REF_MISMATCH: "TAX_REF_MISMATCH",
  NOT_CONFIRMED: "NOT_CONFIRMED",
  PASSWORD_TOO_SHORT: "PASSWORD_TOO_SHORT",
  NOT_CURRENT_PASSWORD: "NOT_CURRENT_PASSWORD",
  ORDER_STUCK_AFTER_PAYMENT: "ORDER_STUCK_AFTER_PAYMENT",
  MEDIA_SKU_NOT_FOUND: "MEDIA_SKU_NOT_FOUND",
  UPLOAD_SERVICE_ERROR: "UPLOAD_SERVICE_ERROR",
  PRINTABLE_NOT_FOUND: "PRINTABLE_NOT_FOUND",
  TOO_MANY_REQUESTS: "TOO_MANY_REQUESTS"
};

// src/services/cornerstone/generated/model/monetaryAmountCurrency.ts
var MonetaryAmountCurrency = {
  USD: "USD",
  CAD: "CAD",
  EUR: "EUR",
  GBP: "GBP",
  AUD: "AUD"
};

// src/services/cornerstone/generated/model/pricingRuleType.ts
var PricingRuleType = {
  BASE_PRICE: "BASE_PRICE",
  ADDITIONAL_PAGES: "ADDITIONAL_PAGES",
  OPTION_UPGRADE: "OPTION_UPGRADE"
};

// src/services/cornerstone/generated/model/projectInternalStatus.ts
var ProjectInternalStatus = {
  CREATED: "CREATED",
  AWAITING_PROCESSING: "AWAITING_PROCESSING",
  READY: "READY",
  FAILED: "FAILED"
};

// src/services/cornerstone/generated/model/projectType.ts
var ProjectType = {
  WALLART: "WALLART",
  PDF_BOOK: "PDF_BOOK"
};

// src/services/cornerstone/generated/model/searchCondition.ts
var SearchCondition = {
  BETWEEN: "BETWEEN",
  CONTAINS: "CONTAINS",
  EQUALS: "EQUALS",
  IN: "IN",
  NOT_EQUALS: "NOT_EQUALS"
};

// src/services/cornerstone/generated/model/shippingTier.ts
var ShippingTier = {
  ECONOMY: "ECONOMY",
  STANDARD: "STANDARD",
  EXPRESS: "EXPRESS"
};

// src/services/cornerstone/generated/model/supportedCurrency.ts
var SupportedCurrency = {
  USD: "USD",
  CAD: "CAD",
  EUR: "EUR",
  GBP: "GBP",
  AUD: "AUD"
};

// src/services/cornerstone/generated/model/supportedLanguage.ts
var SupportedLanguage = {
  EN: "EN",
  FR: "FR",
  DE: "DE",
  NL: "NL",
  PT: "PT",
  IT: "IT",
  ES: "ES"
};

// src/services/cornerstone/generated/model/transactionStatus.ts
var TransactionStatus = {
  QUEUED: "QUEUED",
  SUCCESSFUL: "SUCCESSFUL",
  FAILED: "FAILED"
};

// src/services/cornerstone/generated/model/transactionType.ts
var TransactionType = {
  SALE: "SALE",
  REFUND: "REFUND",
  VOID: "VOID"
};

// src/services/cornerstone/generated/model/widthCalculationType.ts
var WidthCalculationType = {
  CALCULATED_SOFTCOVER: "CALCULATED_SOFTCOVER",
  BY_PAGE_COUNT_RANGES: "BY_PAGE_COUNT_RANGES"
};

// src/services/cornerstone/other.ts
var other_exports = {};
__export(other_exports, {
  getProjectPreview: () => getProjectPreview,
  useProjectPreview: () => useProjectPreview
});
import axios3 from "axios";
var getProjectPreview = (previewHash) => {
  return axios3.get(`${API_URL.assetService}/hash/${previewHash}`);
};
var useProjectPreview = createQuery2(
  "project-preview",
  getProjectPreview
);

// src/services/index.ts
var API_URL = {};
function setupClients(setupCallback, apiUrl) {
  if (apiUrl) API_URL = apiUrl;
  return setupCallback({
    connector: client_default,
    cornerstone: client_default2
  });
}

// src/utils/query.util.ts
import { useQuery as useQuery11 } from "@tanstack/react-query";
function useApiQuery(request, variables, options) {
  return useQuery11(
    ["@rpi/api", request.name, variables],
    () => __async(this, null, function* () {
      return yield Promise.resolve(
        request(
          ...Array.isArray(variables) ? variables : [variables]
        )
      );
    }),
    options
  );
}

// src/helpers/constants.ts
import { AxiosError as AxiosError2 } from "axios";
var _ConstantsService = class _ConstantsService {
  constructor() {
    this.constants = _ConstantsService.loadFromStorage();
    this.promise = null;
  }
  static loadFromStorage() {
    try {
      const stringValue = localStorage.getItem(
        _ConstantsService.LOCALSTORAGE_KEY
      );
      if (!stringValue) return null;
      const parsed = JSON.parse(stringValue);
      if (!("data" in parsed) || !("hash" in parsed)) {
        throw new Error(`Invalid ${_ConstantsService.name} cache`);
      }
      return parsed;
    } catch (error) {
      console.error(error);
      localStorage.removeItem(_ConstantsService.LOCALSTORAGE_KEY);
      return null;
    }
  }
  static saveToStorage(data) {
    localStorage.setItem(
      _ConstantsService.LOCALSTORAGE_KEY,
      JSON.stringify(data)
    );
  }
  fetchAndMatch() {
    return __async(this, null, function* () {
      var _a, _b;
      try {
        const response = yield generated_exports.getConstants({
          headers: __spreadValues({}, this.constants && {
            "If-None-Match": this.constants.hash
          })
        });
        const storageData = {
          data: response.data,
          hash: (_a = response.headers.etag) != null ? _a : `${Date.now()}`
        };
        if (this.constants && this.constants.hash === storageData.hash) {
          return this.constants;
        }
        this.constants = storageData;
        _ConstantsService.saveToStorage(storageData);
        return storageData;
      } catch (error) {
        if (!(error instanceof AxiosError2) || ((_b = error.response) == null ? void 0 : _b.status) !== 304) {
          console.error("Failed to load constants", error);
        }
        return null;
      }
    });
  }
  load() {
    return __async(this, null, function* () {
      if (this.constants) {
        if (!this.promise) {
          this.promise = this.fetchAndMatch();
        }
        return this.constants;
      }
      if (this.promise) {
        return yield this.promise;
      }
      this.promise = this.fetchAndMatch();
      return yield this.promise;
    });
  }
  get() {
    var _a, _b;
    return (_b = (_a = this.constants) == null ? void 0 : _a.data) != null ? _b : {};
  }
};
_ConstantsService.LOCALSTORAGE_KEY = "@blurb/cornerstone-constants";
var ConstantsService = _ConstantsService;
var constantsService = new ConstantsService();
var constants = null;
var constantsPromise = null;
function loadConstants() {
  return __async(this, null, function* () {
    if (constants) return constants;
    if (!constantsPromise) {
      constantsPromise = generated_exports.getConstants();
    }
    constants = (yield constantsPromise).data;
    return constants;
  });
}
function awaitConstants() {
  return __async(this, null, function* () {
    if (constants) return constants;
    if (!constantsPromise) return loadConstants();
    return (yield constantsPromise).data;
  });
}
function getConstants2() {
  return constants != null ? constants : {};
}

// src/provider.tsx
var provider_exports = {};
__export(provider_exports, {
  Provider: () => Provider,
  queryClient: () => queryClient
});
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { jsx } from "react/jsx-runtime";
var queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
});
var Provider = ({ children }) => {
  return /* @__PURE__ */ jsx(QueryClientProvider, { client: queryClient, children });
};

// src/utils/url.ts
var isValidUrl = (url) => {
  if (!url) {
    return false;
  }
  try {
    new URL(url);
    return true;
  } catch (error) {
    return false;
  }
};
var getBlurbCoreUrl = ({
  hostname,
  blurbCoreUrl,
  f5BlurbCoreUrl
}) => {
  var _a;
  const isBlurbCoreValid = isValidUrl(blurbCoreUrl);
  const isF5BlurbCoreValid = isValidUrl(f5BlurbCoreUrl);
  const defaultUrl = "https://beta-api.test.blurb.internal/blurb-core";
  const isDev = hostname.includes("dev.future") || hostname === "localhost" || hostname === "127.0.0.1";
  const searchString = isDev ? (_a = new URLSearchParams(window.location.search).get("urlSearchOverride")) != null ? _a : "future" : "future";
  if (isBlurbCoreValid && isF5BlurbCoreValid) {
    return hostname.includes(searchString) ? blurbCoreUrl : f5BlurbCoreUrl;
  }
  if (isBlurbCoreValid) {
    return blurbCoreUrl;
  }
  if (isF5BlurbCoreValid) {
    return f5BlurbCoreUrl;
  }
  return defaultUrl;
};
export {
  API_URL,
  requests_exports as ConnectorApi,
  mutations_exports as ConnectorMutation,
  queries_exports as ConnectorQuery,
  ConstantsService,
  generated_exports as Cornerstone,
  other_exports as CornerstoneOther,
  provider_exports as RpiApi,
  awaitConstants,
  constantsService,
  createApiMutation,
  createApiQuery,
  getBlurbCoreUrl,
  getConstants2 as getConstants,
  loadConstants,
  pathParams,
  setupClients,
  useApiQuery
};
